import { Fragment, useEffect, useState, useRef, useMemo } from "react";
import { getToken, getMessaging, onMessage } from "firebase/messaging";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { axiosGet, axiosPost } from "../services/axiosService";
import { variableParser } from "../services/parserService";
import {
  handleLogicalOperator,
  handleComparisonOperator,
} from "../services/conditionService";
import { BotComponent, UserComponent } from "./ChatComponent";
import env from "../services/environment";
import validateData from "../services/validationService";
import CountryCodeData from "./CountryCode";
import "../services/firebaseService";
import "../style/preview.css";
import { BotIconOld, WhiteBotIcon } from "./Icons";
import { deleteCookies, setCookie, getCookie } from "../services/cookieService";
import { io } from "socket.io-client";
import { calculate } from "../services/calculator.service";
import flatObject from "@/utils/flatObject";
import useScrollStore from "@/services/useScrollStore";
import VoiceCoach from "./VoiceCoach";
import { nanoid } from "nanoid";
import { useCalendlyEventListener } from "react-calendly";
import getTextColor from "@/utils/getTextColor";

const PREDEFINED_VARIABLES = [
  "location",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
];
const environmentData = env();
const socket = io(environmentData.SERVER_API_URL + "/live-calc", {
  transports: ["websocket"],
  autoConnect: false,
});

function Preview(props: any) {
  const {
    embed,
    environment,
    reload,
    consent,
    setConsent,
    setReadPdf,
    setReadPdfText,
  } = props;
  const router = useNavigate();
  const [searchParams, _] = useSearchParams();
  const debug = useRef<boolean>(searchParams.has("debug"));
  const localEnv = window.location.hostname.includes("local") ? true : false;
  const senderId = useMemo(() => {
    const temp = getCookie("senderId")
      ? getCookie("senderId")
      : String(Math.floor(Math.random() * 1000000));
    return temp;
  }, []);
  const botData = props?.botData ?? {};
  const [variableData, setVariableData] = useState<Record<string, string>>({});
  const [userCredential, setUserCredential] = useState({
    id: senderId,
    email: "",
    phone: "",
    name: "",
    salesForce: "",
  });
  const [chatConfig, setChatConfig] = useState<any>(props?.botData?.chatConfig);
  const [questions, setQuestions] = useState<any>([]);
  const [isReplyValid, setIsReplyValid] = useState(true);
  const [error, setError] = useState("");
  const [botCustomId, setBotCustomId] = useState("");
  const [botId, setBotId] = useState("");
  const [botName, setBotName] = useState<any>();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<any>(null);
  const [roomId, setRoomId] = useState(null);
  const [buttonVariables, setButtonVariables] = useState<any>([]);
  const [islast, setIsLast] = useState<boolean>(false);
  const [showNotification, setShowNotification] = useState<any>(false);
  const [notificationData, setNotificationData] = useState<any>();
  const [phoneDropDown, setPhoneDropDown] = useState<boolean>(false);
  const [isAnswerSaved, setIsAnswerSaved] = useState<boolean>(false);
  const [countryCodeIndex, setCountryCodeIndex] = useState<number>(234);
  const [showError, setShowError] = useState<boolean>(false);
  const phoneDropRef = useRef<any>();
  const [botType, setBotType] = useState<string>("");
  const [newReply, setNewReply] = useState("");
  const [responseLoader, setResponseLoader] = useState<boolean>(false);
  const [textColor, setTextColor] = useState<any>("");
  const [emailCheck, setemailCheck] = useState(true);
  const [starterQues, setStarterQues] = useState<any>();
  const [tempStore, setTempStore] = useState<any>();
  const [activeCat, setActiveCat] = useState<any>();
  const country = useRef<any>();
  const [arr, setArr] = useState<any>([]);
  const [arr2, setArr2] = useState<any>([]);
  const [arr3, setArr3] = useState<any>([]);
  const [isLiveChat, setIsLiveChat] = useState<any>([]);
  const [checkMsg, setCheckMsg] = useState<any>(false);
  const [checkIndex, setCheckIndex] = useState<any>(false);
  const [checkValidate, setCheckValidate] = useState<any>(false);
  const [message, setMessage] = useState<any>([]);
  const [assignedUser, setAssignedUser] = useState<any>({});
  const userInputRef = useRef<any>();
  const nudgeConfig = botData?.aiBotConfig?.nudgeConfig;
  const person = 1;
  const ai = 0;
  const [disableInput, setDisableInput] = useState<any>();
  const nudgeTimer = useRef<any>();
  const responseTimer = useRef<any>();
  const nudgeTimer2 = useRef<any>();
  const finalMsg = useRef<any>();
  const isSkip = useRef<boolean>(true);
  const regenerate = useRef<any>();
  const [isTrained, setIsTrained] = useState<boolean>(false);
  const scrollRef = useRef<any>();
  const [suggestedQuesAns, setSuggestedQuesAns] = useState<boolean>(false);
  finalMsg.current = message[message.length - 1];
  const inputRef = useRef<HTMLInputElement>(null);
  const [startLiveChat, setStartLiveChat] = useState(false);
  const liveChatSocketRef = useRef<any>();
  const [liveChatNode, setLiveChatNode] = useState<any>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const isScrollSource = useScrollStore((state) => state.isScrollSource);
  const intercomData = useRef<Record<string, any> | null>(null);
  const zendeskData = useRef<Record<string, any> | null>(null);
  const crispData = useRef<Record<string, any> | null>(null);
  const processedAgentMsg = useRef(new Set<string>());
  const [calendlyConfig, setCalendlyConfig] = useState<any>({});
  const [chatHandler, setChatHandler] = useState<
    "web" | "ai" | "intercom" | "zendesk" | "crisp"
  >("web");
  const socketRoomId = useRef(nanoid());
  const [collectUserVars, setCollectUserVars] = useState<string[]>([]);
  const [collectUserVarData, setCollectUserVarData] = useState<
    Record<string, string>
  >({});
  const queryRequestSignal = useRef<AbortController>();
  const [chatSummary, setChatSummary] = useState("");
  const [nextChatSummaryStart, setNextChatSummaryStart] = useState(0);
  const [chatSummaryPending, setChatSummaryPending] = useState(false);
  const [overLimit, setOverLimit] = useState(false);
  const [locationData, setLocationData] = useState<Record<string, any>>(
    props.locationData,
  );
  const [contactData, setContactData] = useState<Record<string, any> | null>(
    null,
  );
  const contactId = useRef(window.localStorage.getItem("cbb-contact-id") ?? "");

  const showRetry = useMemo(() => {
    if (!environmentData.isAI || chatHandler !== "ai") return false;

    const lastMessage = message.at(-1);
    if (!lastMessage) return false;
    if (lastMessage.author === ai && !lastMessage.text.length) return true;

    return false;
  }, [message]);

  useCalendlyEventListener({
    onEventScheduled: (e) => {
      handleHumanAgentMessage({
        message: `Meeting scheduled successfully.`,
        commentId: e.data.payload.event.uri,
      });
    },
  });
  const mergedSalesForcePayload = questions.reduce(
    (acc: Record<string, any>, question) => {
      if (question.name === "salesForce" && question.salesForceData?.payload) {
        return { ...acc, ...question.salesForceData.payload };
      }
      return acc;
    },
    {},
  );
  const firstMessage = useRef<any[]>([]);

  // useEffect(() => {
  //   // if there is senderId cookie, then fetch the chat history
  //   const fetchParticularLiveChat = async () => {
  //     if (senderId) {
  //       try {
  //         const response = await axiosGet(
  //           `/users/particularLiveChat?senderId=${getCookie("senderId")}`,
  //         );
  //         const messages =
  //           response?.data?.data?.userAnswers
  //             .map((userAnswer) => ({
  //               author: ai,
  //               timestamp: new Date(userAnswer.date),
  //               text: userAnswer.nodeTitle,
  //             }))
  //             .concat(
  //               response?.data?.data?.userAnswers.map((userAnswer) => ({
  //                 author: person,
  //                 timestamp: new Date(userAnswer.date),
  //                 text: userAnswer.userAnswer,
  //               })),
  //             ) ?? [];

  //         messages.sort((a, b) => a.timestamp - b.timestamp);

  //         setMessage(messages);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //   };

  //   fetchParticularLiveChat();
  // }, []);

  const onTouchMove = () => {
    if (inputRef.current && document.activeElement === inputRef.current) {
      inputRef.current.blur();
    }
  };

  const handleStop = async () => {
    queryRequestSignal.current?.abort();
    setResponseLoader(false);
    // setStop(true);
  };

  useEffect(() => {
    if (responseLoader) {
      if (responseTimer.current) {
        clearTimeout(responseTimer.current);
      }

      if (responseTimer.current) {
        clearTimeout(responseTimer.current);
      }

      responseTimer.current = setTimeout(() => {
        setResponseLoader(false);

        setMessage((prevMessages) => {
          const lastMessage = prevMessages[prevMessages.length - 1];

          if (lastMessage?.isLoader) {
            handleStop();
            queryRequestSignal.current?.abort();
            console.log("STREAMING ABORTED AS LAST MESSAGE IS LOADER");
            return prevMessages.slice(0, -1);
          } else {
            console.log("STREAMING NOT ABORTED AS LAST MESSAGE IS NOT LOADER");
            return prevMessages;
          }
        });
      }, 45000);
    }

    return () => {
      clearTimeout(responseTimer.current);
    };
  }, [responseLoader, message, handleStop]);

  useEffect(() => {
    const handleSessionOut = async (e) => {
      e.preventDefault();
      if (!islast) {
        axiosPost(`/livebot/chatfinished`, {
          roomId,
          collectUserVars,
        });
      }
      if (botData?.chatTranscript)
        axiosGet(`/livebot/sendChatTranscript?roomId=${roomId}`);
      return (e.returnValue = "You have unfinished changes!");
    };

    if (env()?.isAI && roomId && !embed) {
      // if (!nudgeConfig?.collectNudgeDetails) {
      window.addEventListener("beforeunload", handleSessionOut, true);
      // } else {
      // window.removeEventListener("beforeunload", handleSessionOut, true);
      // }
    }
    // return () => {
    //   window.removeEventListener("beforeunload", handleSessionOut, true);
    // };
  }, [nudgeConfig, roomId]);

  useEffect(() => {
    triggerNudge(botData?.aiBotConfig?.nudgeConfig);
  }, [newReply]);

  useEffect(() => {
    if (
      !env()?.isAI &&
      ((botType == "ai" && !isTrained) ||
        ["button", "sendMessage"].includes(
          questions[currentQuestionIndex ?? 0]?.name,
        ))
    )
      setDisableInput(true);
    else setDisableInput(false);
  }, [currentQuestionIndex]);

  useEffect(() => {
    const utmStrings = {};

    searchParams.forEach((value, key) => {
      if (key.toLowerCase().startsWith("utm_")) {
        utmStrings[key.toLowerCase()] = value;
      }
    });

    setVariableData((pre) => ({ ...pre, ...utmStrings }));

    if (!localEnv && "serviceWorker" in navigator) {
      onMessage(getMessaging(), (payload) => {
        if (payload) {
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(false);
          }, 10000);
        }
      });
    }
  }, []);

  useEffect(() => {
    let font;
    const id = "dynamic-font";
    if (document.getElementById(id)) {
      font = document.getElementById(id);
      font.href = chatConfig?.typography?.font?.fontURL;
    } else {
      font = document.createElement("link");
      font.rel = "stylesheet";
      font.id = id;
      font.href = chatConfig?.typography?.font?.fontURL;
      document.head.appendChild(font);
    }
  }, [chatConfig?.typography]);

  // useEffect(() => {
  //   if (typeof document === "undefined") return;
  //   const style = document.createElement("style");
  //   style.innerHTML = `${chatConfig.customCSS}`;
  //   document.head.appendChild(style);
  // }, [chatConfig.customCSS]);

  useEffect(() => {
    const selectedColor = chatConfig?.botBubbleColor;
    document.documentElement.style.setProperty(
      "--dynamic-color",
      chatConfig?.botBubbleColor,
    );

    const color = getTextColor(selectedColor);
    setTextColor(color);
  }, [chatConfig?.botBubbleColor]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [message, suggestedQuesAns, isScrollSource]);

  useEffect(() => {
    if (islast) {
      if (startLiveChat) {
        setIsLast(false);
      } else {
        // const varNames = generateCollectUserVar();
        // axiosPost(`/livebot/chatfinished`, {
        //   roomId,
        //   varNames,
        // });

        deleteCookies("senderId");
        if (botData?.chatTranscript)
          axiosGet(`/livebot/sendChatTranscript?roomId=${roomId}`);
      }
    }
  }, [islast]);

  useEffect(() => {
    processBotData();
    processLocationData();

    if (props.resumeConversationData) {
      processResumeChat(props.resumeConversationData);
    }

    // setMessage([]);
    // setChatHandler("web");
    // setResponseLoader(false);
  }, []);

  async function processBotData() {
    try {
      const {
        _id,
        botCustomId,
        questions,
        projectName,
        startNodeId,
        botType,
        aiBotConfig,
        companyId,
      } = botData;

      if (env().isAI) {
        await checkAILimit(companyId);
      }

      if (aiBotConfig?.containsLiveChat)
        setLiveChatNode(questions.find((ques) => ques.name === "liveChat"));
      processQuestions(questions);

      const currentIndex = questions.findIndex(
        (ele) => ele.drawFlowId === startNodeId,
      );

      const _collectUserVars = generateCollectUserVar(botData);
      setCollectUserVars(_collectUserVars);
      if (
        botData.aiStarterQues?.initialMsg &&
        botData.aiStarterQues?.data.length
      ) {
        setTempStore(botData.aiStarterQues?.data);
        setCheckMsg(!!botData.aiStarterQues?.initialMsg);
      }
      if (!chatConfig) {
        setChatConfig(botData.chatConfig);
      }
      setBotId(_id);
      setBotCustomId(botCustomId);
      setQuestions(questions);
      setBotName(projectName);
      setCurrentQuestionIndex(currentIndex);
      setBotType(botType);
      setIsTrained(
        botData.aiSource?.youtube?.length ||
          botData.aiSource?.confluence?.length ||
          botData.aiSource?.urls?.length ||
          botData.aiSource?.googlepicker?.length ||
          botData.aiSource?.notion?.length ||
          botData.aiSource?.urls?.length ||
          botData.aiSource?.salesforce?.length ||
          botData.aiSource?.documents?.length ||
          !!Object.keys(botData.aiSource?.textArea)?.length,
      );

      await triggerNudge(botData.aiBotConfig?.nudgeConfig);
    } catch (err) {
      if (environment === "live") router("/error");
    }
  }

  async function checkAILimit(companyId: string) {
    const res = await axiosGet(`/livebot/check-limit?companyId=${companyId}`);
    setOverLimit(res.data.rateLimit);
  }

  async function processResumeChat(resumeConversationData) {
    const messages: any[] = [];

    for (const data of resumeConversationData.userAnswers) {
      if (data.userAnswer === "NO_REPLY") {
        messages.push({
          author: ai,
          timestamp: new Date(data.date),
          text: data.nodeTitle,
        });
      } else {
        messages.push({
          author: person,
          timestamp: new Date(data.date),
          text: data.userAnswer,
        });
        messages.push({
          author: ai,
          timestamp: new Date(data.date),
          text: data.nodeTitle,
        });
      }
    }

    setRoomId(resumeConversationData._id);
    setMessage(messages);
    setChatHandler("ai");
  }

  async function initiateChatLoader() {
    setMessage((prevItems) => [
      ...prevItems,
      {
        author: ai,
        timestamp: new Date(),
        isLoader: true,
        text: "Loading...",
      },
    ]);
  }

  async function removeChatLoader() {
    setMessage((prevItems: any) => {
      const tempMessage = structuredClone(prevItems);
      const lastMessage = tempMessage[tempMessage.length - 1];
      if (lastMessage.isLoader) {
        tempMessage.pop();
      }
      return tempMessage;
    });
  }

  function processQuestions(questions) {
    let sortedArr: any = [];
    let sortedArr2: any = [];
    let sortedArr3: any = [];
    questions.forEach((data) => {
      if (
        data?.name == "email" ||
        data?.name == "phone" ||
        data?.name == "ask_question"
      ) {
        if (
          data.data.title.durationData == "messages" &&
          data.data.title.durationVal > 1
        ) {
          sortedArr3.push(data);
        } else if (
          data.data.title.durationData == "minutes" &&
          data.data.title.durationVal > 0
        )
          sortedArr.push(data);
        else sortedArr2.push(data);
      } else if (data?.name === "liveChat") {
        setIsLiveChat(data);
      }
    });

    sortedArr3.sort(
      (a, b) => a?.data.title?.durationVal - b?.data?.title.durationVal,
    );
    sortedArr.sort(
      (a, b) => a?.data.title?.durationVal - b?.data?.title.durationVal,
    );
    const newArr3 = sortedArr3.map((data) => {
      return {
        author: ai,
        timestamp: new Date(),
        text: data.data.title,
        name: data.name,
        hasAnswered: false,
        completeData: data,
      };
    });
    setArr3(newArr3);

    const newArr2 = sortedArr2.map((data) => {
      return {
        author: ai,
        timestamp: new Date(),
        text: data.data.title,
        name: data.name,
        hasAnswered: false,
        completeData: data,
      };
    });
    setArr2(newArr2);
    sortedArr.map((data) => {
      setTimeout(
        () => {
          setArr((prev) => [
            ...prev,
            {
              author: ai,
              timestamp: new Date(),
              text: data.data.title,
              name: data.name,
              hasAnswered: false,
              completeData: data,
            },
          ]);
        },
        data.data.title.durationVal * 24 * 1000,
      );
    });
  }

  function generateCollectUserVar(botData) {
    const varNames: string[] = [];

    for (const tool of botData.aiBotConfig.tools ?? []) {
      if (tool.type !== "collectUserData") continue;
      for (const name in tool.valuePrompts) {
        varNames.push(name);
      }
    }

    return varNames;
  }

  async function processLocationData() {
    try {
      const locationRes = await axiosGet("/livebot/getLocation");
      const { country, regionName, city, ip } = locationRes.data?.data;

      const locationData = {
        ip: ip?.ip_address,
        location: `${city}, ${regionName}, ${country}`,
        country: country?.toLowerCase() ?? "",
        region: regionName?.toLowerCase() ?? "",
        city: city?.toLowerCase() ?? "",
      };

      setLocationData(locationData);

      setVariableData((pre) => ({ ...pre, ...locationData }));

      if (country) {
        const countryIndex = CountryCodeData.findIndex(
          (data) => data.name === country,
        );
        setCountryCodeIndex(countryIndex);
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const handleCountryCodeScroll = (event) => {
      const index: number = CountryCodeData.findIndex(
        (ele) => ele.name.slice(0, 1).toLowerCase() === event.key,
      );
      phoneDropRef.current.scrollTop = 33 * index;
    };

    if (phoneDropDown)
      window.addEventListener("keydown", handleCountryCodeScroll);
    else window.removeEventListener("keydown", handleCountryCodeScroll);
    return () => window.removeEventListener("keydown", handleCountryCodeScroll);
  }, [phoneDropDown]);

  async function handleLiveChatNode(liveChatNodeIndex: number) {
    const tempNodeTitle = variableParser(
      questions[liveChatNodeIndex]?.data?.title?.value ??
        questions[liveChatNodeIndex]?.data?.title,
      variableData,
    );

    // to save the initial nodeTitle
    axiosPost(`/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}`, {
      botCustomId: botCustomId,
      nodeTitle: tempNodeTitle,
      drawFlowId: questions[liveChatNodeIndex]?.drawFlowId ?? 0,
      userAnswer: "NO_REPLY",
      variableData: {},
      userCredential,
      contactId: contactId.current,
    }).then(() => {
      setMessage((prevItems) => [
        ...prevItems,
        {
          author: ai,
          timestamp: new Date(),
          text: tempNodeTitle,
        },
      ]);

      // creates a webSocket and starts the liveChat
      setStartLiveChat(true);
    });
    setArr2((prev: any) => {
      const [_, ...remains] = prev;
      return remains;
    });
    isSkip.current = true;
  }

  useEffect(() => {
    if (currentQuestionIndex !== null && currentQuestionIndex >= 0) {
      if (questions[currentQuestionIndex]?.name === "button") {
        let optionsKeys = Object.keys(questions[currentQuestionIndex]?.data);
        let indexOfTitle = optionsKeys.findIndex(
          (optionsKeys) => optionsKeys === "title",
        );
        let optionValues = Object.values(questions[currentQuestionIndex]?.data);
        let title: any = "";
        let AllButtonoptions: any = [];

        questions[currentQuestionIndex]?.buttonDetails?.buttons?.map((item) => {
          let option = item;
          let newOptionTitle = variableParser(item.name, variableData);
          option.name = newOptionTitle;
          AllButtonoptions.push(option);
        });
        title = variableParser(
          (optionValues[indexOfTitle] as string) ?? "",
          variableData,
        );

        setMessage((prevItems) => [
          ...prevItems,
          {
            author: ai,
            timestamp: new Date(),
            text: title,
            options: AllButtonoptions,
            hasAnswered: false,
            name: questions[currentQuestionIndex]?.name,
            completeData: questions[currentQuestionIndex],
            // isStater: true,
          },
        ]);
      } else if (questions[currentQuestionIndex]?.name === "sendMessage") {
        const titleData = variableParser(
          questions[currentQuestionIndex]?.data?.title,
          variableData,
          null,
          mergedSalesForcePayload,
        );
        setMessage((prevItems) => [
          ...prevItems,
          {
            author: ai,
            timestamp: new Date(),
            text: titleData,
            name: questions[currentQuestionIndex]?.name,
            hasAnswered: false,
            completeData: questions[currentQuestionIndex],
          },
        ]);
        setDisableInput(true);
        handleSendNoReplyMessage(titleData);
      } else if (questions[currentQuestionIndex]?.name === "salesForce") {
        const salesForceData =
          questions[currentQuestionIndex]?.salesForceData?.payload || {};

        const salesforceData = variableParser(
          questions[currentQuestionIndex + 1]?.data?.title || "",
          variableData,
          null,
          mergedSalesForcePayload,
        );
        if (salesforceData) {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
      } else if (
        questions[currentQuestionIndex]?.name === "email" ||
        questions[currentQuestionIndex]?.name === "name" ||
        questions[currentQuestionIndex]?.name === "job" ||
        questions[currentQuestionIndex]?.name === "company" ||
        questions[currentQuestionIndex]?.name === "phone" ||
        questions[currentQuestionIndex]?.name === "username" ||
        questions[currentQuestionIndex]?.name === "address" ||
        questions[currentQuestionIndex]?.name === "ask_question" ||
        questions[currentQuestionIndex]?.name === "liveChat"
      ) {
        if (questions[currentQuestionIndex] !== undefined) {
          const titleData = variableParser(
            questions[currentQuestionIndex]?.data?.title,
            variableData,
          );
          const nodeTitle = questions[currentQuestionIndex]?.data?.title;
          if (
            nodeTitle.durationData === "minutes" &&
            nodeTitle.durationVal > 0
          ) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
          } else if (
            nodeTitle.durationData === "messages" &&
            nodeTitle.durationVal > 1
          ) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
          } else if (nodeTitle.durationData === "Let AI Decide") {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
          } else {
            setMessage((prevItems) => [
              ...prevItems,
              {
                author: ai,
                timestamp: new Date(),
                text: titleData,
                name: questions[currentQuestionIndex]?.name,
                hasAnswered: false,
                completeData: questions[currentQuestionIndex],
              },
            ]);
            setArr2((prev: any) => {
              const [_, ...remains] = prev;
              return remains;
            });
            isSkip.current = true;
          }
        }
      } else if (questions[currentQuestionIndex]?.name === "sendEmail") {
        let index = message.findIndex((x) => x.name === "email");
        let sendTo = "";
        let sendEmailDetails =
          questions[currentQuestionIndex]?.sendEmailDetails;
        if (message[index + 1] !== undefined) {
          sendTo = message[index + 1].text;
        }
        handleSendEmailNode(sendTo, sendEmailDetails);
      } else if (questions[currentQuestionIndex]?.name === "sendSMS") {
        let index = message.findIndex((x) => x.name === "phone");
        let sendTo = "";
        let sendSMSDetails = questions[currentQuestionIndex]?.sendSMSDetails;
        if (message[index + 1] !== undefined) {
          sendTo = message[index + 1].text;
        }
        handleSendSMSNode(sendTo, sendSMSDetails);
      } else if (questions[currentQuestionIndex]?.name === "whatsApp") {
        let index = message.findIndex((x) => x.name === "phone");
        let sendTo = "";
        console.log(questions[currentQuestionIndex], "current question index");
        let sendWhatsappDetails =
          questions[currentQuestionIndex]?.whatsappDetails;
        if (message[index + 1] !== undefined) {
          sendTo = message[index + 1].text;
        }
        handleWhatsappData(sendTo, sendWhatsappDetails);
      } else if (questions[currentQuestionIndex]?.name === "whatsAppTemplate") {
        // aviator
        console.log(questions[currentQuestionIndex]?.name);
        let index = message.findIndex((x) => x.name === "phone");
        let sendTo = "";
        let sendWhatsappDetails =
          questions[currentQuestionIndex]?.whatsappDetails;
        if (message[index + 1] !== undefined) {
          sendTo = message[index + 1].text;
        }
        handleWhatsappTemplate(sendTo, sendWhatsappDetails);
      } else if (questions[currentQuestionIndex]?.name === "result") {
        handleCalculateResult(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "hitApi") {
        handleHitApi(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "pushNotification") {
        handlePushNotification(
          questions[currentQuestionIndex]?.pushNotification,
        );
      } else if (questions[currentQuestionIndex]?.name === "socialData") {
        if (
          questions[currentQuestionIndex]?.outputs[0].connections !== undefined
        ) {
          let currentIndex = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              questions[currentQuestionIndex]?.outputs[0].connections.node,
          );
          setCurrentQuestionIndex(currentIndex);
        } else {
          setIsLast(true);
        }
      } else if (questions[currentQuestionIndex]?.name === "envoie") {
        handleEnvoieData(
          questions[currentQuestionIndex]?.templateDetails,
          questions[currentQuestionIndex],
        );
      } else if (questions[currentQuestionIndex]?.name === "abTest") {
        handleABTest(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "condition") {
        handleCondition(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "segment") {
        handleCondition(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "delayAction") {
        handleDelayAction(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "ai") {
        setChatHandler("ai");
      } else if (questions[currentQuestionIndex]?.name === "assignees") {
        let node: any = questions[currentQuestionIndex];
        let tempAssignee: string = "";
        if (node.assigneesData.logicType == "round_robin") {
          let roundRobinData: any = node.assigneesData.roundRobinData;
          let assigneesIds: string[] = Object.keys(roundRobinData);
          let lastIndex: number = assigneesIds.length - 1;
          for (let i = 0; i <= lastIndex; i++) {
            if (
              i == lastIndex ||
              roundRobinData[assigneesIds[i]] <=
                roundRobinData[assigneesIds[i + 1]]
            ) {
              tempAssignee = assigneesIds[i];
              break;
            }
          }
        } else {
          let conditionalData = node.assigneesData.conditionalData;
          let elseAssignee = conditionalData[conditionalData.length - 1];
          for (let i = 0; i < conditionalData.length - 1; i++) {
            let condition = conditionalData[i];
            let innerConditions = condition.conditions;
            let isTrue = false;
            for (let j = 0; j < innerConditions.length; j++) {
              let userAnswer = "" + variableData[innerConditions[j].variable];
              let value = "" + innerConditions[j].value;
              userAnswer = userAnswer.toLowerCase().trim();
              value = value.toLowerCase().trim();
              if (innerConditions[j].comparison_operator == "includes") {
                if (innerConditions[j].logical_operator == "and") {
                  isTrue = userAnswer?.includes(value) && isTrue;
                } else {
                  if (isTrue) break;
                  isTrue = userAnswer?.includes(value);
                }
              } else {
                if (innerConditions[j].logical_operator == "and") {
                  // isTrue = eval(`userAnswer${innerConditions[j].comparison_operator}value`) && isTrue;
                  isTrue =
                    evalCondition(
                      userAnswer,
                      innerConditions[j].comparison_operator,
                      value,
                    ) && isTrue;
                } else {
                  if (isTrue) break;
                  // isTrue = eval(`userAnswer${innerConditions[j].comparison_operator}value`);
                  isTrue = evalCondition(
                    userAnswer,
                    innerConditions[j].comparison_operator,
                    value,
                  );
                }
              }
            }
            if (isTrue) {
              tempAssignee = condition.assigneeId;
              break;
            }
          }
          if (!tempAssignee) {
            tempAssignee = elseAssignee?.assigneeId;
          }
        }

        const variableDataToSend = {};
        const varName = node.name;
        if (varName) variableDataToSend[varName] = tempAssignee;

        setVariableData((pre) => ({ ...pre, ...variableDataToSend }));

        const conversation: any[] = [];
        for (const index in message) {
          if (+index === message.length - 1) break;
          if (message[+index + 1]?.author) {
            conversation.push({
              question: message[+index].text,
              answer: message[+index + 1].text,
            });
          }
        }

        axiosPost(
          `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${variableData?.location}`,
          {
            botCustomId: botCustomId,
            nodeTitle: node.data.title,
            drawFlowId: node.drawFlowId ?? 0,
            userAnswer: tempAssignee,
            variableName: varName,
            variableData: variableDataToSend,
            userCredential,
            adminId: botData.userId,
            conversation,
            contactId: contactId.current,
          },
        )
          .then((response) => {
            if (roomId === null) {
              setRoomId(response.data.roomId);
            }
            setAssignedUser(response.data.assigneeInfo);

            if (
              questions[currentQuestionIndex]?.outputs[0].connections !==
              undefined
            ) {
              let currentIndex = questions.findIndex(
                (x) =>
                  x.drawFlowId ===
                  questions[currentQuestionIndex]?.outputs[0].connections.node,
              );
              setCurrentQuestionIndex(currentIndex);
            } else {
              setIsLast(true);
            }
          })
          .catch((err: any) => {
            console.log(err);
          });
      } else if (questions[currentQuestionIndex]?.name === "linkedIn") {
        handleLinkedIn(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "openai") {
        handleOpenAINode(questions[currentQuestionIndex]);
      } else if (questions[currentQuestionIndex]?.name === "liveChat") {
        const nodeTitle = questions[currentQuestionIndex]?.data?.title;
        if (nodeTitle.durationData === "minutes" && nodeTitle.durationVal > 0) {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else if (
          nodeTitle.durationData === "messages" &&
          nodeTitle.durationVal > 1
        ) {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
          handleLiveChatNode(currentQuestionIndex);
        }
      } else {
        if (!questions[currentQuestionIndex]?.outputs[0]?.connections)
          return setIsLast(true);
        const currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId ===
            questions[currentQuestionIndex]?.outputs[0].connections?.node,
        );
        setCurrentQuestionIndex(currentIndex);
      }
    }
  }, [currentQuestionIndex]);

  async function handleOpenAINode(nodeData: any) {
    try {
      const { showParams, params, prompt, configId } = nodeData?.openAiData;

      const checkedItems = {};
      if (showParams) {
        params?.forEach((item) => {
          if (item.isCheck) {
            checkedItems[item.name] = item.value;
          } else {
            checkedItems[item.name] = item.defaultValue;
          }
        });
      }

      const dataToSend = {
        configId: configId,
        prompt: variableParser(prompt, variableData),
        showParams: showParams,
        ...checkedItems,
      };
      await initiateChatLoader();
      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${questions[currentQuestionIndex].name}_${questions[currentQuestionIndex]?.drawFlowId}`,
          nodeType: questions[currentQuestionIndex]?.nodeType,
          drawFlowId: questions[currentQuestionIndex]?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          variableData,
          contactId: contactId.current,
        },
      );

      const response = await axiosPost("/liveBot/openAiResponse", {
        ...dataToSend,
        roomId,
        botId,
        botCustomId,
        nodeDrawflowId: questions[currentQuestionIndex].drawFlowId,
        answerId: answerResponse?.data?.answerId,
        onLive: true,
      });

      const variable = { [nodeData.variableName]: response?.data?.data };
      setVariableData((pre) => ({ ...pre, ...variable }));
    } catch (err) {
      console.log(err);
      const variable = { [nodeData.variableName]: "Something went wrong" };
      setVariableData((pre) => ({ ...pre, ...variable }));
    } finally {
      if (!questions[currentQuestionIndex]?.outputs[0].connections)
        return setIsLast(true);
      const currentIndex = questions.findIndex(
        (x) =>
          x.drawFlowId ===
          questions[currentQuestionIndex]?.outputs[0].connections?.node,
      );
      setCurrentQuestionIndex(currentIndex);
      await removeChatLoader();
    }
  }

  async function handleLinkedIn(nodeData: any) {
    try {
      const parsedData = {};
      for (const key in nodeData.linkedInData) {
        parsedData[key] = variableParser(
          nodeData.linkedInData[key],
          variableData,
          "",
        );
      }
      await initiateChatLoader();

      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${questions[currentQuestionIndex].name}_${questions[currentQuestionIndex]?.drawFlowId}`,
          nodeType: questions[currentQuestionIndex]?.nodeType,
          drawFlowId: questions[currentQuestionIndex]?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          variableData,
          contactId: contactId.current,
        },
      );
      const response = await axiosPost("/liveBot/linkedIn", {
        ...parsedData,
        roomId,
        botId,
        botCustomId,
        nodeDrawflowId: questions[currentQuestionIndex].drawFlowId,
        answerId: answerResponse?.data?.answerId,
      });
      const { profileId, profileData } = response.data.data;
      const linkedInVariables = {};
      const nodeId = nodeData.drawFlowId;

      linkedInVariables[`${nodeId}_profileId`] = profileId;
      if (profileData) {
        linkedInVariables[`${nodeId}_publicId`] = profileData.publicId;
        linkedInVariables[`${nodeId}_firstName`] = profileData.firstName;
        linkedInVariables[`${nodeId}_lastName`] = profileData.lastName;
        linkedInVariables[`${nodeId}_location`] = profileData.location;
        linkedInVariables[`${nodeId}_headline`] = profileData.headline;
        linkedInVariables[`${nodeId}_industry`] = profileData.industry;
        linkedInVariables[`${nodeId}_summary`] = profileData.summary || "";
      }

      setVariableData((pre) => ({ ...pre, ...linkedInVariables }));
    } catch (err) {
      console.log(err);
    } finally {
      if (!questions[currentQuestionIndex]?.outputs[0].connections)
        return setIsLast(true);
      const currentIndex = questions.findIndex(
        (x) =>
          x.drawFlowId ===
          questions[currentQuestionIndex]?.outputs[0].connections?.node,
      );
      setCurrentQuestionIndex(currentIndex);
      await removeChatLoader();
    }
  }

  const evalCondition = (userResponse: any, operator: any, value: any) => {
    switch (operator) {
      case "EQUAL TO":
        return userResponse == value;
      case "NOT EQUAL TO":
        return userResponse != value;
      case "LESS THAN":
        return userResponse < value;
      case "GREATER THAN":
        return userResponse > value;
      case "GREATER THAN EQUAL TO":
        return userResponse >= value;
      case "LES THAN EQUAL TO":
        return userResponse <= value;
      default:
        return false;
    }
  };
  const handleEnvoieData = async (templateDetails, completeData) => {
    axios
      .get(
        `https://api.envoie.email/v1/builder/exportTemplate/${templateDetails.templateId}`,
        {
          headers: { "x-api-key": templateDetails.apiKey },
        },
      )
      .then((response) => {
        const emailTemp = response.data.data.html;
        const emailVariable = completeData.variableName;
        const variableDatatoSend = { [emailVariable]: emailTemp };
        setVariableData((pre) => ({ ...pre, ...variableDatatoSend }));

        return axiosPost(
          `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${variableData?.location}`,
          {
            botCustomId: botCustomId,
            nodeTitle: "Envoie data",
            variableData: variableDatatoSend,
            drawFlowId: questions[currentQuestionIndex].drawFlowId ?? 0,
            userAnswer: emailTemp,
            variableName: emailVariable,
            userCredential,
            contactId: contactId.current,
          },
        );
      })
      .then((response) => {
        if (roomId === null) {
          setRoomId(response.data.roomId);
        }
      })
      .finally(() => {
        if (
          questions[currentQuestionIndex]?.outputs[0].connections !== undefined
        ) {
          let currentIndex = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              questions[currentQuestionIndex]?.outputs[0].connections.node,
          );
          setCurrentQuestionIndex(currentIndex);
        } else {
          setIsLast(true);
        }
      });
  };

  const handleWhatsappData = async (sendTo, whatsappDetails) => {
    await axiosGet(
      `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
    ).then((response) => {
      return axiosPost("/webhook/sendMessageAndTemplate", {
        lang: whatsappDetails.lang,
        configId: whatsappDetails.phoneNumberId,
        templateName: whatsappDetails.templateName,
        message: variableParser(whatsappDetails.smsBody, {
          ...variableData,
          ...response.data.data,
        }),
        // to: variableParser(whatsappDetails?.to ?? sendTo, { ...variableData, ...response.data.data }),
        to: sendTo,
        components: variableParser(whatsappDetails.components ?? null),
      });
    });
    if (questions[currentQuestionIndex]?.outputs[0].connections !== undefined) {
      let currentIndex = questions.findIndex(
        (x) =>
          x.drawFlowId ===
          questions[currentQuestionIndex]?.outputs[0].connections.node,
      );
      setCurrentQuestionIndex(currentIndex);
    } else {
      setIsLast(true);
    }
  };

  const handleWhatsappTemplate = async (sendTo, templateDetails) => {
    console.log(templateDetails, "templateDetails");
    await axiosGet(
      `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
    ).then((response) => {
      return axiosPost("/webhook/sendTemplates", {
        to: sendTo,
        templateName: templateDetails.templateName,
        configId: templateDetails.phoneNumberId,
        lang: templateDetails.lang,
        components: variableParser(templateDetails.components ?? null),
      });
    });
    if (questions[currentQuestionIndex]?.outputs[0].connections !== undefined) {
      let currentIndex = questions.findIndex(
        (x) =>
          x.drawFlowId ===
          questions[currentQuestionIndex]?.outputs[0].connections.node,
      );
      setCurrentQuestionIndex(currentIndex);
    } else {
      setIsLast(true);
    }
  };

  const handleSendNoReplyMessage = async (title) => {
    try {
      const variableDataToSend = {};
      for (const variableName in variableData) {
        if (PREDEFINED_VARIABLES.includes(variableName))
          variableDataToSend[variableName] = variableData[variableName];
      }

      if (
        environmentData?.isAI &&
        questions[currentQuestionIndex].drawFlowId == 1
      ) {
        firstMessage.current = [
          {
            botCustomId: botCustomId,
            nodeTitle: typeof title === "string" ? title : (title?.value ?? ""),
            drawFlowId: questions[currentQuestionIndex].drawFlowId ?? 0,
            userAnswer: "NO_REPLY",
            variableData:
              variableDataToSend && Object.keys(variableDataToSend).length > 0
                ? variableDataToSend
                : {
                    location: `${locationData.city}, ${locationData.regionName}, ${locationData.country}`,
                  },
            userCredential,
            nodeType: questions[currentQuestionIndex].nodeType,
          },
        ];
      }

      if (
        !(
          environmentData?.isAI &&
          questions[currentQuestionIndex].drawFlowId == 1
        )
      ) {
        const response = await axiosPost(
          `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${
            `location: ${locationData.city}, ${locationData.regionName}, ${locationData.country}` ||
            "Not Detected"
          }`,
          {
            botCustomId: botCustomId,
            nodeTitle: typeof title === "string" ? title : (title?.value ?? ""),
            drawFlowId: questions[currentQuestionIndex].drawFlowId ?? 0,
            userAnswer: "NO_REPLY",
            variableData:
              variableDataToSend && Object.keys(variableDataToSend).length > 0
                ? variableDataToSend
                : {
                    location: `${locationData.city}, ${locationData.regionName}, ${locationData.country}`,
                  },
            userCredential,
            nodeType: questions[currentQuestionIndex].nodeType,
            contactId: contactId.current,
          },
        );
        setRoomId(response.data.roomId);
      }

      let pendingMsg = { ...arr3[0] };
      if (
        arr2.length === 0 &&
        checkMsg &&
        ((pendingMsg.hasOwnProperty("text") &&
          message.length < pendingMsg?.text?.durationVal) ||
          !pendingMsg.hasOwnProperty("text"))
      ) {
        setStarterQues(tempStore);
        if (botData?.aiStarterQues?.initialMsg?.trim().length > 0) {
          setMessage((prevItems) => [
            ...prevItems,
            {
              author: ai,
              timestamp: new Date(),
              text: botData?.aiStarterQues?.initialMsg,
            },
          ]);
        }
        isSkip.current = true;
        setCheckMsg(false);
        setDisableInput(false);
        return;
      } else if (
        pendingMsg.hasOwnProperty("text") &&
        message.length >= pendingMsg?.text?.durationVal &&
        arr2.length === 0
      ) {
        isSkip.current = true;
        setArr3((prev: any) => {
          const [_, ...pendings] = prev;
          return pendings;
        });
        setMessage((prevItems) => [...prevItems, pendingMsg]);
      } else if (
        questions[currentQuestionIndex]?.outputs[0].connections !== undefined
      ) {
        let currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId ===
            questions[currentQuestionIndex]?.outputs[0].connections.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        if (chatHandler === "ai") {
          setCurrentQuestionIndex(questions.length - 1);
          setDisableInput(false);
          setCheckIndex(false);
          return;
        }
        setIsLast(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSendEmailNode = async (sendTo, sendEmailDetails) => {
    try {
      let from = "";
      let nodeData = questions[currentQuestionIndex];
      if (sendEmailDetails.from.includes("assignees"))
        from = assignedUser.userEmail;
      else if (sendEmailDetails.from.includes("@"))
        from = sendEmailDetails.from;

      const response = await axiosGet(
        `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
      );
      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${nodeData.name}_${nodeData?.drawFlowId}`,
          nodeType: nodeData?.nodeType,
          drawFlowId: nodeData?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          variableData,
          contactId: contactId.current,
        },
      );

      const answerId = answerResponse?.data?.answerId;

      const subject = variableParser(
        sendEmailDetails?.content.subject,
        {
          ...variableData,
          ...response.data.data,
        },
        null,
        mergedSalesForcePayload,
      );
      const to = variableParser(
        sendEmailDetails.to ? sendEmailDetails.to : sendTo,
        {
          ...variableData,
          ...response.data.data,
        },
        null,
        mergedSalesForcePayload,
      );
      const replyTo = variableParser(
        sendEmailDetails.replyTo ?? "",
        {
          ...variableData,
          ...response.data.data,
        },
        null,
        mergedSalesForcePayload,
      );
      const tempBody = `${variableParser(
        sendEmailDetails?.content.body,
        {
          ...variableData,
          ...response.data.data,
        },
        null,
        mergedSalesForcePayload,
      )} <img src='${
        env()?.SERVER_API_URL
      }/livebot/updateAnalyticData?node=email&action=opened&answerId=${answerId}&status=${environment}&variableName=email_opened_${
        nodeData?.drawFlowId
      }' style="display:none"></img>`;

      const anchorRegex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/gi;

      // Replace anchor tags with modified href
      const body = tempBody.replace(anchorRegex, (match, quote, href) => {
        return `<a href="${
          env()?.SERVER_API_URL
        }/livebot/updateAnalyticData?node=email&action=linkClicked&answerId=${answerId}&url=${encodeURIComponent(
          href,
        )}">click here</a>`;
      });

      const res = await axiosPost("/liveBot/sendEmail", {
        emailConfigId: sendEmailDetails.emailConfig,
        from,
        sendTo: to,
        subject: subject,
        html: body,
        replyTo: replyTo ?? "",
        botId: botId,
        botCustomId: botCustomId,
        roomId,
        answerId: answerId,
        status: environment,
        drawFlowId: nodeData?.drawFlowId,
      });
    } catch (err) {
      console.log(err);
    } finally {
      if (
        questions[currentQuestionIndex]?.outputs[0].connections !== undefined
      ) {
        let currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId ===
            questions[currentQuestionIndex]?.outputs[0].connections.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        setIsLast(true);
      }
    }
  };

  const handleSendSMSNode = async (sendTo, sendSMSDetails) => {
    try {
      const response = await axiosGet(
        `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
      );
      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${questions[currentQuestionIndex].name}_${questions[currentQuestionIndex]?.drawFlowId}`,
          nodeType: questions[currentQuestionIndex]?.nodeType,
          drawFlowId: questions[currentQuestionIndex]?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          variableData,
          contactId: contactId.current,
        },
      );

      const body = variableParser(sendSMSDetails.smsBody, {
        ...variableData,
        ...response.data.data,
      });

      const res = await axiosPost("/liveBot/sendSms", {
        smsConfigId: sendSMSDetails.smsConfig,
        smsBody: variableParser(sendSMSDetails?.smsBody, {
          ...variableData,
          ...response.data.data,
        }),
        botId: botId,
        botCustomId: botCustomId,
        answerId: answerResponse?.data?.answerId,
        userNumber: variableParser(sendSMSDetails?.to ?? sendTo, {
          ...variableData,
          ...response.data.data,
        }),
      });
    } catch (err: any) {
      console.log(error);
    } finally {
      if (
        questions[currentQuestionIndex]?.outputs[0].connections !== undefined
      ) {
        let currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId ===
            questions[currentQuestionIndex]?.outputs[0].connections.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        setIsLast(true);
      }
    }

    axiosGet(
      `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
    )
      .then((response) => {
        const body = variableParser(sendSMSDetails.smsBody, {
          ...variableData,
          ...response.data.data,
        });
        return axiosPost("/liveBot/sendSms", {
          smsConfigId: sendSMSDetails.smsConfig,
          smsBody: variableParser(sendSMSDetails?.smsBody, {
            ...variableData,
            ...response.data.data,
          }),
          botId: botId,
          botCustomId: botCustomId,
          userNumber: variableParser(sendSMSDetails?.to ?? sendTo, {
            ...variableData,
            ...response.data.data,
          }),
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        if (
          questions[currentQuestionIndex]?.outputs[0].connections !== undefined
        ) {
          let currentIndex = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              questions[currentQuestionIndex]?.outputs[0].connections.node,
          );
          setCurrentQuestionIndex(currentIndex);
        } else {
          setIsLast(true);
        }
      });
  };

  const handlePushNotification = async (pushNotification) => {
    let nodeData = questions[currentQuestionIndex];
    try {
      const messaging = getMessaging();

      const tokenKey: string =
        "BF0RHPAtFXbMXB6KPaCbK1K__GoNIF8WV7mGfP_Htngnsvp-upSrOrtDBBVTkKyVRmdJ_xKXAmFEa4RsvAVP9Sw";

      const token = await getToken(messaging, { vapidKey: tokenKey });
      const permission = await Notification.requestPermission();

      if (permission !== "granted") throw new Error("Permission denied");

      const response = await axiosGet(
        `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
      );
      const varParsedTitle = variableParser(pushNotification.title, {
        ...variableData,
        ...response.data.data,
      });
      const varParsedBody = variableParser(pushNotification.body, {
        ...variableData,
        ...response.data.data,
      });
      setNotificationData({
        ...pushNotification,
        title: varParsedTitle,
        body: varParsedBody,
      });

      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${nodeData.name}_${nodeData?.drawFlowId}`,
          nodeType: questions[currentQuestionIndex]?.nodeType,
          drawFlowId: questions[currentQuestionIndex]?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          variableData,
          contactId: contactId.current,
        },
      );

      await axiosPost("/liveBot/sendNotification", {
        botId: botId,
        botCustomId: botCustomId,
        configId: pushNotification.pushConfigId,
        token: token,
        title: varParsedTitle,
        body: varParsedBody,
        deliveryStatus: "delivered",
      });
    } catch (err) {
      console.log(err);
      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${nodeData.name}_${nodeData?.drawFlowId}`,
          nodeType: questions[currentQuestionIndex]?.nodeType,
          drawFlowId: questions[currentQuestionIndex]?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          deliveryStatus: "Permission denied",
          variableData,
          contactId: contactId.current,
        },
      );
    } finally {
      if (
        questions[currentQuestionIndex]?.outputs[0].connections !== undefined
      ) {
        let currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId ===
            questions[currentQuestionIndex]?.outputs[0].connections.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        setIsLast(true);
      }
    }
  };

  const handleSendMessageNode = (sendTo, sendSMSDetails) => {
    axiosGet(
      `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
    )
      .then((response) => {
        const body = variableParser(sendSMSDetails.smsBody, response.data.data);
        return axiosPost("/liveBot/sendSms", {
          smsConfigId: sendSMSDetails.smsConfig,
          smsBody: variableParser(sendSMSDetails?.smsBody, response.data.data),
          botId: botId,
          botCustomId: botCustomId,
          userNumber: variableParser(
            sendSMSDetails?.to ?? sendTo,
            response.data.data,
          ),
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        if (
          questions[currentQuestionIndex]?.outputs[0].connections !== undefined
        ) {
          let currentIndex = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              questions[currentQuestionIndex]?.outputs[0].connections.node,
          );
          setCurrentQuestionIndex(currentIndex);
        } else {
          setIsLast(true);
        }
      });
  };

  const handleButtonReply = (
    currentIndex,
    buttonSelected,
    buttonSelectedIndex,
    buttonValue,
    buttonImage = "",
  ) => {
    let oldMessages = [...message];
    let indexToUpdate = message.length - 1;
    oldMessages[indexToUpdate].hasAnswered = true;
    setMessage(oldMessages);

    setMessage((prevItems) => [
      ...prevItems,
      {
        author: person,
        timestamp: new Date(),
        text: buttonSelected,
        value: buttonValue,
        image: buttonImage,
      },
    ]);
    isSkip.current = true;
    let varName =
      message[currentIndex].completeData.variableName !== undefined
        ? message[currentIndex].completeData.variableName
        : null;
    let insideVarName =
      message[currentIndex].completeData.buttonDetails.variableName;
    const valuefButton =
      message[currentIndex].completeData.buttonDetails.buttons[
        buttonSelectedIndex
      ].value;

    let oldButtonVariables = [...buttonVariables];
    let newObj = {
      name: message[currentIndex].completeData.buttonDetails.variableName,
      value: valuefButton,
    };
    oldButtonVariables.push(newObj);
    setButtonVariables(oldButtonVariables);

    let variableDataToSend = {};
    if (varName !== null) {
      variableDataToSend = {
        [varName]: buttonSelected,
        [insideVarName]: valuefButton,
      };
    }

    setVariableData((pre) => ({ ...pre, ...variableDataToSend }));
    axiosPost(
      `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${variableData?.location}`,
      {
        botCustomId: botCustomId,
        nodeTitle: message[currentIndex].completeData.data.title,
        drawFlowId: message[currentIndex].completeData.drawFlowId ?? 0,
        userAnswer: buttonSelected,
        variableName: varName,
        variableData: variableDataToSend,
        userCredential,
        contactId: contactId.current,
      },
    )
      .then((response) => {
        if (roomId === null) {
          setRoomId(response.data.roomId);
        }
        if (
          message[currentIndex].completeData?.outputs[0]?.connectionId ==
            "output_0" &&
          message[currentIndex].completeData?.outputs[0]?.connections?.node
        ) {
          let currentIndexValue = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              message[currentIndex].completeData?.outputs[0]?.connections.node,
          );
          setCurrentQuestionIndex(currentIndexValue);
        } else if (
          message[currentIndex].completeData?.outputs[buttonSelectedIndex]
            ?.connections !== undefined
        ) {
          let currentIndexValue = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              message[currentIndex].completeData?.outputs[buttonSelectedIndex]
                ?.connections.node,
          );
          setCurrentQuestionIndex(currentIndexValue);
        } else {
          setIsLast(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getSimpleObject = (data, mainKey = "") => {
    let obj = {};
    const objKeys = Object.keys(data ?? {});
    objKeys.forEach((key) => {
      if (typeof data[key] !== "object") {
        if (mainKey.length > 0)
          obj = { ...obj, [`${mainKey}.${key}`]: data[key] };
        else obj = { ...obj, [`${key}`]: data[key] };
      } else if (Array.isArray(data[key])) {
        const arr = data[key];
        const arrLen = data[key].length;

        let temoObj = convertArrayToObj(arr, key);
        temoObj = getSimpleObject(temoObj, mainKey);
        obj = { ...obj, ...temoObj };
      } else {
        let tempObj = {};
        if (mainKey.length > 0)
          tempObj = getSimpleObject(data[key], `${mainKey}.${key}`);
        else tempObj = getSimpleObject(data[key], `${key}`);
        obj = { ...obj, ...tempObj };
      }
    });
    return obj;
  };

  const convertArrayToObj = (arr, key) => {
    let obj = {};
    arr.forEach((a, index) => {
      obj[`${key}.${index}`] = a;
    });
    return obj;
  };

  const handleHitApi = async (apiNodeData) => {
    try {
      if (!apiNodeData?.hitApiDetails) throw new Error("API data empty");
      await initiateChatLoader();

      const headers = parseApiData(apiNodeData.hitApiDetails.headers);
      const params = parseApiData(apiNodeData.hitApiDetails.params);
      const body = parseApiData(apiNodeData.hitApiDetails.headers);

      const response = await axiosPost("/livebot/testCallAPI", {
        method: apiNodeData.hitApiDetails.method,
        url: apiNodeData.hitApiDetails.url,
        headers,
        params,
        data: body,
      });

      const flatResponse = flatObject(response.data);
      const apiVariables = {};

      for (const variable of apiNodeData.hitApiDetails?.variables ?? []) {
        apiVariables[variable.customName] = flatResponse[variable.name];
      }

      setVariableData((per) => ({ ...per, ...apiVariables }));

      if (
        questions[currentQuestionIndex]?.outputs[0].connections !== undefined
      ) {
        let currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId ===
            questions[currentQuestionIndex]?.outputs[0]?.connections?.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        setIsLast(true);
      }
    } catch (err) {
      console.log(err);
      if (
        questions[currentQuestionIndex]?.outputs[1]?.connections !== undefined
      ) {
        let currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId ===
            questions[currentQuestionIndex].outputs[1]?.connections?.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        setIsLast(true);
      }
    } finally {
      await removeChatLoader();
    }
  };

  function parseApiData(data: Array<Row>) {
    const result: Record<string, string> = {};

    for (const item of data) {
      if (!item.key) continue;
      result[item.key] = variableParser(item.value, variableData);
    }

    return result;
  }

  const handleCalculateResult = async (nodeData) => {
    const formula = nodeData.resultNodeDetails.formula;
    const processedFormula = variableParser(formula, variableData);

    let result;
    try {
      if (/[{}]/.test(processedFormula)) {
        throw new Error("Un-parsed variable exist");
      }

      result = calculate(processedFormula);
    } catch (err) {
      console.log(err);
      result = "Invalid formula";
    }

    const variableDataToSend = { [nodeData?.variableName]: result };
    setVariableData((pre) => ({ ...pre, ...variableDataToSend }));
    axiosPost(
      `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${variableData?.location}`,
      {
        botCustomId: botCustomId,
        nodeTitle: questions[currentQuestionIndex]?.data.title,
        drawFlowId: questions[currentQuestionIndex]?.drawFlowId ?? 0,
        userAnswer: "NO_REPLY",
        variableName: nodeData?.variableName,
        variableData: variableDataToSend,
        userCredential,
        contactId: contactId.current,
      },
    ).then((response) => {
      // SET ROOM ID IF NOT AVAILABLE
      if (roomId === null) {
        setRoomId(response.data.roomId);
      }
    });
    if (questions[currentQuestionIndex]?.outputs[0].connections !== undefined) {
      let currentIndex = questions.findIndex(
        (x) =>
          x.drawFlowId ===
          questions[currentQuestionIndex]?.outputs[0].connections.node,
      );
      setCurrentQuestionIndex(currentIndex);
    } else {
      setIsLast(true);
    }
  };

  const handleABTest = async (nodeData) => {
    try {
      const drawflowId = nodeData?.drawFlowId;
      if (nodeData.status === "dev")
        throw new Error("A/B testing only supported in live bot");

      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${nodeData.name}_${nodeData?.drawFlowId}`,
          nodeType: nodeData?.nodeType,
          drawFlowId: nodeData?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          variableData,
          contactId: contactId.current,
        },
      );
      const response = await axiosGet(
        `/liveBot/abTest?botCustomId=${botCustomId}&drawFlowId=${drawflowId}&answerId=${answerResponse?.data?.answerId}`,
      );
      const outputIndex = response.data.path === "a" ? 0 : 1;

      if (nodeData?.outputs[outputIndex].connections) {
        const currentIndex = questions.findIndex(
          (x) =>
            x.drawFlowId === nodeData.outputs[outputIndex].connections.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        setIsLast(true);
      }
    } catch (err) {
      console.log(err);
      if (nodeData?.outputs[0].connections) {
        const currentIndex = questions.findIndex(
          (x) => x.drawFlowId === nodeData.outputs[0].connections.node,
        );
        setCurrentQuestionIndex(currentIndex);
      } else {
        setIsLast(true);
      }
    }
  };

  const handleCondition = async (nodeData) => {
    let check: boolean = false;
    try {
      let isSendEmailNodeExist = false;
      questions.forEach((ques, index) => {
        if (ques.name == "sendEmail") {
          isSendEmailNodeExist = true;
        }
      });
      let response;
      if (isSendEmailNodeExist) {
        response = await axiosGet(
          `/liveBot/updateEmailData?roomId=${roomId}&botId=${botId}&status=${environment}`,
        );
      } else {
        response = await axiosGet(
          `/liveBot/getVariableData?roomId=${roomId}&botId=${botId}&status=${environment}`,
        );
      }
      const variablesData = response.data.data ?? {};
      const { conditionData } = nodeData;

      check = await conditionData.reduce((prev: boolean, cur) => {
        const variable_data = variablesData[cur.variable];
        const value_data = variableParser(cur.value, variableData);

        const temp: boolean = handleComparisonOperator(
          variable_data,
          value_data,
          cur.comparison_operator,
        );

        return handleLogicalOperator(prev, temp, cur.logical_operator);
      }, true);

      if (check) {
        if (questions[currentQuestionIndex]?.outputs[0].connections) {
          let currentIndex = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              questions[currentQuestionIndex]?.outputs[0]?.connections.node,
          );
          setCurrentQuestionIndex(currentIndex);
        } else {
          setIsLast(true);
        }
      } else {
        if (questions[currentQuestionIndex]?.outputs[1].connections) {
          let currentIndex = questions.findIndex(
            (x) =>
              x.drawFlowId ===
              questions[currentQuestionIndex].outputs[1]?.connections.node,
          );
          setCurrentQuestionIndex(currentIndex);
        } else {
          setIsLast(true);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      const answerResponse = await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
        {
          botCustomId: botCustomId,
          nodeTitle: `${nodeData.name}_${nodeData?.drawFlowId}`,
          nodeType: nodeData?.nodeType,
          drawFlowId: nodeData?.drawFlowId,
          userAnswer: "NO_REPLY",
          userCredential,
          variableData,
          deliveryStatus: check ? "Delivered" : "Not Delivered",
          contactId: contactId.current,
        },
      );
    }
  };
  const handleDelayAction = async (nodeData) => {
    if (!nodeData?.outputs[0].connections) return setIsLast(true);
    const nextIdex = questions.findIndex(
      (x) => x.drawFlowId === nodeData?.outputs[0].connections.node,
    );

    try {
      if (!roomId) throw new Error("Preview: skip to next to node");
      // const answerResponse = await axiosPost(`/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`, {
      //   botCustomId: botCustomId,
      //   nodeTitle: `${nodeData.name}_${nodeData?.drawFlowId}`,
      //   nodeType: questions[currentQuestionIndex]?.nodeType,
      //   drawFlowId: questions[currentQuestionIndex]?.drawFlowId,
      //   userAnswer: "NO_REPLY",
      //   userCredential,
      //   variableData,
      // });
      axiosPost("/liveBot/delay", {
        botId,
        roomId,
        drawFlowId: nodeData.drawFlowId,
        status: environment,
      });
      setIsLast(true);
    } catch (err) {
      console.log(err);
      setCurrentQuestionIndex(nextIdex);
    }
  };

  const handleStarterQues = async (reply: string) => {
    try {
      if (!islast) {
        let roomID: any = "";

        if (firstMessage.current.length !== 0) {
          const response = await axiosPost(
            `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${
              `location: ${firstMessage.current[0]?.variableData?.location}` ||
              "Not Detected"
            }`,
            {
              botCustomId: botCustomId,
              nodeTitle: firstMessage.current[0].nodeTitle,
              drawFlowId: "1",
              userAnswer: "NO_REPLY",
              variableData: variableData,
              userCredential: userCredential,
              nodeType: firstMessage.current[0].nodeType,
              contactId: contactId.current,
            },
          );

          roomID = response.data.roomId;
          await setRoomId(response.data.roomId);
          firstMessage.current = [];
        }

        await triggerNudge(botData?.aiBotConfig?.nudgeConfig);

        const isStaterQues = true;

        if (!activeCat && botData?.aiStarterQues.isCat) {
          let catQuesAns = botData?.aiStarterQues.data.filter(
            (item) => item.cat === reply,
          );
          setStarterQues(catQuesAns);
          setActiveCat({ text: reply });
        } else {
          setStarterQues(undefined);
          setActiveCat(undefined);
          setTempStore("");
          if (suggestedQuesAns) setSuggestedQuesAns(false);
          let ans = botData?.aiStarterQues?.data?.filter(
            (item) => item.ques == reply,
          );
          setMessage((prevItems: any) => {
            const tempMessage = [...prevItems];
            tempMessage.push({
              author: person,
              timestamp: new Date(),
              text: reply,
            });
            return tempMessage;
          });
          await axiosPost(
            `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId ?? roomID}&country=${variableData?.location}&starterQues=${isStaterQues}`,
            {
              isAiBot: true,
              botCustomId: botCustomId,
              nodeTitle: environmentData.isAI
                ? message[message.length - 1]?.name === "ask_question" ||
                  message[message.length - 1]?.name === "email" ||
                  message[message.length - 1]?.name === "job" ||
                  message[message.length - 1]?.name === "name" ||
                  message[message.length - 1]?.name === "address" ||
                  message[message.length - 1]?.name === "company" ||
                  message[message.length - 1]?.name === "phone"
                  ? message[message.length - 1].text.value
                  : message[message.length - 1].text
                : (message[message.length - 1].text ?? ""),
              drawFlowId: message[currentQuestionIndex]?.drawFlowId ?? 0,
              userAnswer: reply,
              variableName: null,
              variableData: variableData,
              userCredential,
              contactId: contactId.current,
            },
          );
          setMessage((prevItems: any) => {
            const tempMessage = [...prevItems];
            tempMessage.push({
              author: ai,
              timestamp: new Date(),
              text: ans[0]?.ans,
            });
            return tempMessage;
          });
          await axiosPost(
            `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId ?? roomID}&country=${variableData?.location}`,
            {
              //maybe here
              isAiBot: true,
              botCustomId: botCustomId,
              nodeTitle: ans[0]?.ans,
              drawFlowId: message[currentQuestionIndex]?.drawFlowId ?? 0,
              userAnswer: "NO_REPLY",
              variableName: null,
              variableData: variableData,
              userCredential,
              contactId: contactId.current,
            },
          );
          let pendingMsg = { ...arr3[0] };
          if (
            pendingMsg.hasOwnProperty("text") &&
            message.length + 2 >= pendingMsg?.text?.durationVal
          ) {
            isSkip.current = true;
            setArr3((prev: any) => {
              const [_, ...pendings] = prev;
              return pendings;
            });
            setMessage((prevItems) => [...prevItems, pendingMsg]);
            return;
          } else {
            setCurrentQuestionIndex(questions.length - 1);
          }
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      isSkip.current = true;
    }
  };

  const handleNudgeMech = async (nudgeConfig: any) => {
    try {
      let msgToSend = nudgeTimer.current
        ? nudgeConfig?.msg
        : nudgeConfig?.finalMsg;
      setMessage((prevItems: any) => {
        const tempMessage = [...prevItems];
        tempMessage.push({
          author: ai,
          timestamp: new Date(),
          text: msgToSend,
        });
        return tempMessage;
      });
      await axiosPost(
        `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${
          variableData?.location || "Not Detected"
        }`,
        {
          botCustomId: botCustomId,
          nodeTitle: msgToSend,
          drawFlowId: questions[currentQuestionIndex]?.drawFlowId ?? 0,
          userAnswer: "NO_REPLY",
          variableData: {},
          userCredential,
          isAiBot: true,
          contactId: contactId.current,
        },
      );
    } catch (err) {
      console.log(err);
    } finally {
      if (
        (nudgeConfig?.finalMsg && !nudgeTimer.current) ||
        (!nudgeConfig?.finalMsg && nudgeTimer.current)
      ) {
        setIsLast(true);
      }
      if (nudgeTimer.current) nudgeTimer.current = undefined;
    }
  };

  const triggerNudge = async (nudgeConfig: any) => {
    if (nudgeConfig?.collectNudgeDetails) {
      if (nudgeConfig?.msg) {
        clearTimeout(nudgeTimer.current);
        clearTimeout(nudgeTimer2.current);
        nudgeTimer.current = setTimeout(
          () => {
            const lastMessage = message[message.length - 1];
            if (!lastMessage?.isLoader) {
              handleNudgeMech(nudgeConfig);
            }
          },
          (nudgeConfig?.durationUnit === "minutes"
            ? nudgeConfig?.duration * 60
            : nudgeConfig?.duration) * 1000,
        );

        if (nudgeConfig?.finalMsg) {
          clearTimeout(nudgeTimer2.current);
          nudgeTimer2.current = setTimeout(
            () => {
              const lastMessage = message[message.length - 1];
              if (!lastMessage?.isLoader) {
                handleNudgeMech(nudgeConfig);
              }
            },
            (nudgeConfig?.durationUnit === "minutes"
              ? nudgeConfig?.duration * 60
              : nudgeConfig?.duration) *
              1000 *
              2,
          );
        }
      }
    }
  };

  const handleRegenerate = async (retry: boolean) => {
    if (retry && regenerate.current) return;
    regenerate.current = true;
    setMessage((prevItems: any) => {
      const tempMessage = [...prevItems];
      const lastMessage = tempMessage[tempMessage.length - 1];
      if (lastMessage.author == ai) {
        tempMessage.pop();
        tempMessage.pop();
      } else {
        tempMessage.pop();
      }
      return tempMessage;
    });
    handleUserReply(
      message?.length ? message?.length - 1 : 0,
      false,
      message[message?.length - (retry ? 2 : 1)]?.text,
      regenerate.current,
    );
  };

  function setScrappedData(data) {
    const _collectUserVarData = { ...collectUserVarData };
    for (const key in data) {
      const value = data[key];
      if (!value) continue;

      _collectUserVarData[key] = value;
    }
    setCollectUserVarData(_collectUserVarData);
  }

  async function handleUserReply(
    currentIndex,
    isPhone = false,
    replyMsg = newReply,
    regenerated,
  ) {
    try {
      // setStarterQues(undefined);
      // setActiveCat(undefined);
      setIsAnswerSaved(false);
      await triggerNudge(botData?.aiBotConfig?.nudgeConfig);
      const reply = isPhone
        ? CountryCodeData[countryCodeIndex].dial_code.slice(1)
        : replyMsg;
      setNewReply("");
      if (!checkMsg) {
        setTempStore("");
        setStarterQues(undefined);
      }
      if (starterQues) {
        const updateMsgs = message.filter(
          (ele) => ele.text !== botData?.aiStarterQues?.initialMsg,
        );
        setMessage(updateMsgs);
        setChatHandler("ai");
      }
      if (!islast) {
        const tempMessage = [...message];
        tempMessage[message.length - 1].hasAnswered = true;
        setMessage(tempMessage);

        setMessage((prevItems) => [
          ...prevItems,
          {
            author: person,
            timestamp: new Date(),
            text: reply,
          },
        ]);
        let pendingMsg = { ...arr3[0] };
        let pendingQues = { ...arr[0] };
        if (
          arr2.length === 0 &&
          checkMsg &&
          ((pendingMsg.hasOwnProperty("text") &&
            message.length + 1 < pendingMsg?.text?.durationVal) ||
            !pendingMsg.hasOwnProperty("text"))
        ) {
          setStarterQues(tempStore);
          setMessage((prevItems) => [
            ...prevItems,
            {
              author: ai,
              timestamp: new Date(),
              text: botData?.aiStarterQues?.initialMsg,
            },
          ]);
          setCheckMsg(false);
          const variableDataToSend = {};
          const varName = message[currentIndex]?.completeData?.variableName;
          if (varName) variableDataToSend[varName] = reply;
          setVariableData((pre) => ({ ...pre, ...variableDataToSend }));

          const userCredentialData = { ...userCredential };
          if (message[message.length - 1]?.name === "email")
            userCredentialData.email = reply;
          if (message[message.length - 1]?.name === "phone")
            userCredentialData.phone = reply;
          if (message[message.length - 1]?.name === "username")
            userCredentialData.name = reply;
          // if (message[message.length - 1]?.name === "salesForce")
          //   userCredentialData.salesForce = reply;
          setUserCredential(userCredentialData);

          await axiosPost(
            `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${variableData?.location}`,
            {
              isAiBot: true,
              botCustomId: botCustomId,
              nodeTitle: environmentData.isAI
                ? message[message.length - 1]?.name === "ask_question" ||
                  message[message.length - 1]?.name === "email" ||
                  message[message.length - 1]?.name === "job" ||
                  message[message.length - 1]?.name === "name" ||
                  message[message.length - 1]?.name === "address" ||
                  message[message.length - 1]?.name === "company" ||
                  message[message.length - 1]?.name === "phone"
                  ? message[message.length - 1].text.value
                  : message[message.length - 1].text
                : (message[message.length - 1].text ?? ""),
              drawFlowId: message[currentIndex]?.completeData?.drawFlowId ?? 0,
              userAnswer: reply,
              variableName: varName,
              variableData: variableDataToSend,
              userCredential: userCredentialData,
              contactId: contactId.current,
            },
          );

          return;
        } else if (
          (pendingQues.hasOwnProperty("text") && arr2.length === 0) ||
          (pendingMsg.hasOwnProperty("text") &&
            message.length + 1 >= pendingMsg?.text?.durationVal &&
            arr2.length === 0)
        ) {
          if (message.length + 1 >= pendingMsg?.text?.durationVal) {
            isSkip.current = true;
            setArr3((prev: any) => {
              const [_, ...pendings] = prev;
              return pendings;
            });
            setMessage((prevItems) => [...prevItems, pendingMsg]);
          } else if (arr && arr.length > 0) {
            isSkip.current = true;
            setArr((prev: any) => {
              const [_, ...pendings] = prev;
              return pendings;
            });
            setMessage((prevItems) => [...prevItems, pendingQues]);
          }
          const variableDataToSend = {};
          const varName = message[currentIndex]?.completeData?.variableName;
          if (varName) variableDataToSend[varName] = reply;

          setVariableData((pre) => ({ ...pre, ...variableDataToSend }));

          const userCredentialData = { ...userCredential };
          if (message[message.length - 1]?.name === "email")
            userCredentialData.email = reply;
          if (message[message.length - 1]?.name === "phone")
            userCredentialData.phone = reply;
          if (message[message.length - 1]?.name === "username")
            userCredentialData.name = reply;
          // if (message[message.length - 1]?.name === "salesForce")
          //   userCredentialData.salesForce = reply;
          setUserCredential(userCredentialData);

          await axiosPost(
            `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${variableData?.location}`,
            {
              isAiBot: true,
              botCustomId: botCustomId,
              nodeTitle:
                message[message.length - 1]?.name === "ask_question" ||
                message[message.length - 1]?.name === "email" ||
                message[message.length - 1]?.name === "job" ||
                message[message.length - 1]?.name === "name" ||
                message[message.length - 1]?.name === "address" ||
                message[message.length - 1]?.name === "company" ||
                message[message.length - 1]?.name === "phone"
                  ? message[message.length - 1].text.value
                  : (message[message.length - 1].text ?? ""),
              drawFlowId: message[currentIndex]?.completeData?.drawFlowId ?? 0,
              userAnswer: reply,
              variableName: varName,
              variableData: variableDataToSend,
              userCredential: userCredentialData,
              contactId: contactId.current,
            },
          );

          return;
        } else if (startLiveChat) {
          if (!getCookie("senderId")) {
            setCookie("senderId", userCredential?.id);
          }
          const waitingForReply = structuredClone([...message].slice(-1)[0]);
          if (waitingForReply?.author !== 0) {
            waitingForReply.text = "";
          }

          const tempDrawFlowId =
            (startLiveChat
              ? liveChatNode?.drawFlowId
              : questions[currentQuestionIndex]?.drawFlowId) ??
            questions[currentQuestionIndex]?.drawFlowId;

          const data = {
            userAnswer: replyMsg,
            nodeTitle: waitingForReply.text.value ?? waitingForReply?.text,
            date: waitingForReply.timestamp,
            drawFlowId: tempDrawFlowId,
            isAiBot: false,
          };

          liveChatSocketRef.current.emit("userReply", {
            data,
            senderId,
          });
        }
        const variableDataToSend = {};
        const varName = message[currentIndex]?.completeData?.variableName;
        if (varName) variableDataToSend[varName] = reply;
        setVariableData((pre) => ({ ...pre, ...variableDataToSend }));

        const userCredentialData = { ...userCredential };
        if (message[message.length - 1]?.name === "email")
          userCredentialData.email = reply;
        if (message[message.length - 1]?.name === "phone")
          userCredentialData.phone = reply;
        if (message[message.length - 1]?.name === "username")
          userCredentialData.name = reply;
        setUserCredential(userCredentialData);

        let newNodeTitle = structuredClone([...message].slice(-1)[0]);

        if (startLiveChat && newNodeTitle?.author !== 0) {
          newNodeTitle.text = "";
        }

        const tempDrawFlowId =
          (startLiveChat
            ? liveChatNode?.drawFlowId
            : questions[currentQuestionIndex]?.drawFlowId) ??
          questions[currentQuestionIndex]?.drawFlowId;

        axiosPost(
          `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${variableData?.location}&isLiveChat=${startLiveChat}`,
          {
            botCustomId: botCustomId,
            nodeTitle: newNodeTitle.text.value ?? newNodeTitle.text ?? "",
            drawFlowId: tempDrawFlowId,
            userAnswer: reply,
            variableName: varName,
            variableData: variableDataToSend,
            userCredential: userCredentialData,
            isAiBot: true,
            contactId: contactId.current,
          },
        ).then((response) => {
          if (roomId === null) {
            setRoomId(response.data.roomId);
          }
          if (!startLiveChat) {
            if (
              questions[currentQuestionIndex]?.outputs[0].connections !==
              undefined
            ) {
              let currentIndex = questions.findIndex(
                (x) =>
                  x.drawFlowId ===
                  questions[currentQuestionIndex]?.outputs[0].connections.node,
              );
              setCurrentQuestionIndex(currentIndex);
            } else {
              if (
                questions[currentQuestionIndex]?.outputs[0]?.connections !==
                undefined
              ) {
                let currentIndex = questions.findIndex(
                  (x) =>
                    x.drawFlowId ===
                    questions[currentQuestionIndex]?.outputs[0].connections
                      .node,
                );
                setCurrentQuestionIndex(currentIndex);
              } else {
                setIsLast(true);
              }
            }
          }
        });
      } else {
        setMessage((prevItems) => [
          ...prevItems,
          {
            author: person,
            timestamp: new Date(),
            text: reply,
          },
          {
            author: ai,
            timestamp: new Date(),
            isLoader: true,
            text: "Something went wrong please try again later.",
          },
        ]);
      }
    } catch (err) {
      setMessage((prevItems: any) => {
        if (prevItems[prevItems.length - 1]?.isLoader) {
          const tempMessage = structuredClone(prevItems);
          tempMessage.pop();
          return tempMessage;
        }
        return prevItems;
      });
      console.log(err);
    } finally {
      isSkip.current = true;
    }
  }

  async function fetchContact() {
    try {
      if (contactData) return;

      const res = await axiosPost("/contact", {
        companyId: botData.companyId,
        contactId: contactId.current,
        location: locationData.location,
        embedData: props.embedData,
      });

      setContactData(res.data.contact);
      contactId.current = res.data.contact._id ?? "";
      window.localStorage.setItem("cbb-contact-id", res.data.contact._id ?? "");
    } catch (err) {
      console.log(err);
    }
  }

  interface Conversation {
    role: "user" | "assistant";
    content: string;
  }

  function generatePreviousChat() {
    const SUMMARY_THRESHOLD = 30; // after how many message summarization will be triggered

    const conversation: Conversation[] = [];

    for (const data of message) {
      conversation.push({
        role: data.author ? "user" : "assistant",
        content: data?.text?.value ?? data?.text,
      });
    }

    if (conversation.length - nextChatSummaryStart >= SUMMARY_THRESHOLD) {
      summarizeChat(
        conversation.slice(nextChatSummaryStart),
        conversation.length,
      );
    }

    const previousChat = conversation.slice(nextChatSummaryStart);

    if (chatSummary) {
      previousChat.unshift({
        role: "assistant",
        content: chatSummary,
      });
    }

    return previousChat;
  }

  async function summarizeChat(
    conversation: Conversation[],
    conversationEnd: number,
  ) {
    if (chatSummaryPending) return;

    try {
      if (chatSummary) {
        conversation.unshift({
          role: "assistant",
          content: chatSummary,
        });
      }

      const res = await axiosPost("/ai/summarize-chat", {
        conversation,
        collectUserVars,
      });

      setChatSummary(res.data.data.summary ?? "");
      setNextChatSummaryStart(conversationEnd);
      setScrappedData(res.data.data.scrappedData);
    } catch (err) {
      console.log("Chat summary: ", err);
    } finally {
      setChatSummaryPending(false);
    }
  }

  const validateInputData = (
    inputData: any,
    validationType: string,
    check: boolean = false,
  ) => {
    if (
      (validationType === "phone" && isSkip.current) ||
      validationType === "username" ||
      validationType === "address"
    ) {
      setIsReplyValid(false);
      const validated = validateData(
        inputData,
        validationType,
        CountryCodeData[countryCodeIndex].code,
      );
      if (inputData.length === 0) setShowError(false);
      else if (validated) {
        setIsReplyValid(true);
      } else
        setError(
          `Enter a valid ${
            validationType == "phone" ? "Phone number" : validationType
          }`,
        );
    } else if (validationType === "email" && isSkip.current) {
      setIsReplyValid(false);
      const validated = validateData(inputData, validationType);
      if (inputData.length === 0) setShowError(false);
      else if (validated) {
        if (botData?.emailConsent && !check) setError("Field is required");
        else setIsReplyValid(true);
      } else {
        setError("Enter a valid Email Address");
      }
    }
  };

  let timeout;
  const handleEnterSubmit = (
    currentIndex,
    isPhone = false,
    isEmail = false,
  ) => {
    setShowError(true);
    // if(isEmail && !emailCheck) return;
    if (!newReply || !isReplyValid) return;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      handleUserReply(currentIndex, isPhone, newReply, regenerate.current);
    }, 500);
    setShowError(false);
  };

  const handleSendReplyButton = (event: any = false) => {
    if (debounce.current) return;
    debounce.current = true;
    setTimeout(() => {
      debounce.current = false;
    }, 1000);
    if (event) event.preventDefault();
    if (!newReply.trim().length) return;
    if (message[message.length - 1]?.isLoader) return;
    if (!islast) {
      const lastIndex = message.length ? message.length - 1 : 0;
      if (
        message[lastIndex]?.name == "email" &&
        message[lastIndex]?.text?.isValidate &&
        isSkip.current
      ) {
        axiosPost("/liveBot/emailValidation", { newReply }).then((res) => {
          if (!res.data.status) {
            setCheckValidate(true);
            setError("Enter a valid Email Address");
            return;
          }
          setCheckValidate(false);
          setError("");
          handleEnterSubmit(lastIndex, false);
        });
      } else {
        handleEnterSubmit(lastIndex, false);
      }
    }
  };

  const debounce = useRef<any>();

  const handleReaction = async (msg, reaction) => {
    try {
      setMessage((prevItems) =>
        prevItems.map((item) =>
          item.id === msg.id ? { ...item, reaction: reaction } : item,
        ),
      );
      await axiosPost(`/liveBot/userReaction`, {
        botCustomId: botCustomId,
        reaction: reaction,
        questionId: msg.id,
        status: botData.status,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleSkipButton = async () => {
    if (debounce.current) return;
    debounce.current = true;
    setTimeout(() => {
      debounce.current = false;
    }, 1000);
    // const lastIndex = message.length ? message.length - 1 : 0;
    isSkip.current = false;
    await handleSendNoReplyMessage(
      message[message.length - 1]?.completeData?.data?.title,
    );
    setShowError(false);
    setIsReplyValid(true);
    setNewReply("");
  };

  function handleButtomInput(event: any, isCheckBox: boolean = false) {
    if (botType == "ai" && !isTrained) return;
    if (isCheckBox) {
      setemailCheck(event.target.checked);

      validateInputData(newReply, "email", event.target.checked);
    } else {
      const value = event.target.value;

      const lastIndex = message.length ? message.length - 1 : 0;

      if (lastIndex >= 0) {
        // if (["email", "phone"].includes(message[lastIndex].name)) return;
        validateInputData(
          value,
          message[lastIndex]?.name,
          message[lastIndex]?.name === "email" ? emailCheck : false,
        );
      }
      setNewReply(
        message[lastIndex]?.name === "username"
          ? value.replace(/\s/g, "")
          : value,
      );
    }
  }

  const handleClose = () => {
    window.parent.postMessage(
      {
        ...chatConfig,
        embedConfig: botData?.embedConfig,
        close: true,
        omniData: true,
      },
      "*",
    );
  };

  const [currentElem, setCurrentElem] = useState<any>(null);

  const stopScroll = () => {
    if (currentElem) {
      const top =
        currentElem.getBoundingClientRect().top + window.scrollY - 1000;
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }
  };
  const disableScrolling = (elem) => {
    setCurrentElem(elem);
    document.addEventListener("touchend", stopScroll);
    document.addEventListener("mouseup", stopScroll);

    setTimeout(() => {
      stopScroll();
    }, 1);
  };

  const enableScrolling = () => {
    setCurrentElem(null);
    document.removeEventListener("touchend", stopScroll);
    document.removeEventListener("mouseup", stopScroll);
  };

  useEffect(() => {
    socket.connect();
    socket.emit("join", socketRoomId.current);

    return () => {
      socket.disconnect();
    };
  }, []);

  async function handleHumanAgentMessage(data) {
    if (processedAgentMsg.current.has(data.commentId)) {
      return;
    }
    processedAgentMsg.current.add(data.commentId);

    if (
      data.agentType === "zendesk" &&
      (!data.authorId ||
        !zendeskData.current?.userId ||
        data.authorId === zendeskData.current.userId)
    ) {
      return;
    }
    const agentMessage = parseMessage(data.message);

    setMessage((prevItems) => [
      ...prevItems,
      {
        author: ai,
        timestamp: new Date(),
        text: agentMessage,
      },
    ]);

    await axiosPost(
      `/liveBot/saveAnswer?botId=${botId}&roomId=${roomId}&country=${country}`,
      {
        isAiBot: true,
        botCustomId: botCustomId,
        nodeTitle: "",
        drawFlowId: message[currentQuestionIndex]?.drawFlowId ?? 0,
        userAnswer: data.message,
        variableName: null,
        variableData: variableData,
        userCredential,
        contactId: contactId.current,
      },
    );
  }

  useEffect(() => {
    async function handleScheduleCallConnect(data) {
      const { name, email, config } = data;
      setUserCredential((prev) => ({
        ...prev,
        name,
        email,
      }));
      // const { isEnable, configId } = botData?.aiBotConfig?.calendlyConfig ?? {};

      console.log(config, "calendly config");
      if (!config.isEnable) return;
      setCalendlyConfig(config);
      setMessage((prevItems: any) => {
        const tempMessage = structuredClone(prevItems);
        const lastMessage = tempMessage[tempMessage.length - 1];
        if (lastMessage.isLoader) {
          tempMessage.pop();
          tempMessage.push({
            author: ai,
            timestamp: new Date(),
            aiResponse: true,
            name: "show_schedule_call",
            text: "",
          });
        }
        return tempMessage;
      });
    }

    function handleChatSummary(data) {}

    function handleVariableData(data) {
      setScrappedData(data);
    }

    socket.on("human-agent-message", handleHumanAgentMessage);
    socket.on("schedule-call-connect", handleScheduleCallConnect);
    socket.on("chat-summary", handleChatSummary);
    socket.on("variable-data", handleVariableData);

    return () => {
      socket.off("human-agent-message", handleHumanAgentMessage);
      socket.off("schedule-call-connect", handleScheduleCallConnect);
      socket.off("chat-summary", handleChatSummary);
      socket.off("variable-data", handleVariableData);
    };
  }, [roomId, botData, message]);

  const parseMessage = (htmlMessage: string) => {
    const element = document.createElement("div");
    element.innerHTML = htmlMessage;
    return element.textContent;
  };

  const getActiveHumanAgent = async () => {
    let activeHumanAgent: Record<any, any> = {};
    let humanAgentConfig = botData?.aiBotConfig?.humanAgentConfig || {};
    if (typeof humanAgentConfig == "object") {
      Object.keys(humanAgentConfig).forEach((key) => {
        if (
          typeof humanAgentConfig[key] == "object" &&
          humanAgentConfig[key].isEnable
        ) {
          activeHumanAgent = { ...humanAgentConfig[key], agentType: key };
        }
      });
    }
    return activeHumanAgent;
  };

  useEffect(() => {
    if (!botCustomId) return;
    if (!socket) return;
    if (!socket.connected) {
      socket.connect();
    }
    // Join the bot-specific room
    socket.emit("join", { roomId: `bot_${botCustomId}` });

    // Listen for bot-deleted event
    const handleBotDeleted = (data) => {
      if (data.botCustomId === botCustomId) {
        setDisableInput(true);
        setTimeout(() => {
          router("/error");
        }, 100);
      }
    };
    socket.on("bot-deleted", handleBotDeleted);
    return () => {
      socket.off("bot-deleted", handleBotDeleted);
    };
  }, [botCustomId]);

  if (embed) {
    return (
      <div
        className={`preview-container-main embed embed-view-container ${
          chatConfig?.theme === "dark"
            ? "dark-preview-cover-bg"
            : "light-preview-cover-bg"
        }`}
        onScroll={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
      >
        <div
          className={`embed-header !gap-[10px] ${
            chatConfig?.theme === "dark" ? "bg-[#353535]" : "bg-[#EEEEEE]"
          }`}
        >
          {(props.showBackBtn || message.length > 2) && (
            <svg
              className="cp"
              style={{
                fill: `${chatConfig?.theme === "dark" && "white"}`,
                cursor: "pointer",
              }}
              onClick={() => props.onBack()}
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="16"
              viewBox="0 0 9 16"
              fill="none"
            >
              <path
                d="M8.37616 0.517379C8.48069 0.621058 8.56366 0.744406 8.62028 0.880312C8.6769 1.01622 8.70606 1.16199 8.70606 1.30922C8.70606 1.45645 8.6769 1.60222 8.62028 1.73812C8.56366 1.87403 8.48069 1.99738 8.37616 2.10106L3.26823 7.20899C3.1637 7.31267 3.08073 7.43602 3.02411 7.57192C2.96749 7.70783 2.93833 7.8536 2.93833 8.00083C2.93833 8.14806 2.96749 8.29383 3.02411 8.42974C3.08073 8.56564 3.1637 8.68899 3.26823 8.79267L8.37616 13.9006C8.48069 14.0043 8.56366 14.1276 8.62028 14.2635C8.6769 14.3994 8.70605 14.5452 8.70605 14.6924C8.70605 14.8397 8.6769 14.9854 8.62028 15.1213C8.56366 15.2573 8.48069 15.3806 8.37616 15.4843C8.1672 15.692 7.88453 15.8086 7.5899 15.8086C7.29526 15.8086 7.01259 15.692 6.80363 15.4843L1.68455 10.3652C1.05799 9.73786 0.706055 8.88747 0.706055 8.00083C0.706055 7.11419 1.05799 6.2638 1.68455 5.63646L6.80363 0.517379C7.01259 0.309659 7.29526 0.193065 7.5899 0.193065C7.88453 0.193065 8.1672 0.309659 8.37616 0.517379Z"
                fill="#666666"
              />
            </svg>
          )}
          <div className="embed-left-item fx al-cnt gap-[10px]">
            <div className={`flex-cnt h-[50px] rounded-[100px] p-[0px]`}>
              {chatConfig?.logo ? (
                <img
                  src={chatConfig?.logo}
                  alt="boticon"
                  className="!h-[36px] !w-[36px] !rounded-[100px]"
                />
              ) : chatConfig?.theme === "dark" ? (
                <WhiteBotIcon />
              ) : (
                <BotIconOld />
              )}
            </div>
            <div className="embed-header-inner">
              <h3
                className={`${
                  chatConfig?.theme === "dark"
                    ? "text-[#FFFFFF]"
                    : "text-[#444444]"
                }`}
                style={{ fontFamily: chatConfig?.typography?.font?.fontFamily }}
              >
                {chatConfig?.headerName.slice(0, 30)}
              </h3>
              {chatConfig?.showHeaderDesc && (
                <p
                  className={`${
                    chatConfig?.theme === "dark"
                      ? "text-[#FFFFFF] opacity-60"
                      : "text-[#444444]"
                  }`}
                  style={{
                    fontFamily: chatConfig?.typography?.font?.fontFamily,
                  }}
                >
                  {chatConfig?.headerDescription}
                </p>
              )}{" "}
            </div>
          </div>
        </div>
        <div
          className={`previewContainer new-scrollbar embed embed-scroll ${
            chatConfig?.theme === "dark"
              ? "dark-preview-cover-bg"
              : "light-preview-cover-bg"
          } `}
          ref={scrollRef}
        >
          <div className="centered-div embed">
            <div className="chatDataContainer">
              {message?.map((msg, currentIndex) => {
                if (msg.name === "agent-start") {
                  return (
                    <div className="wd-100 flex items-center gap-[15px]">
                      <hr
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "border-[#f8f8f8]"
                            : "border-[#44444421]"
                        } wd-100 border`}
                      />
                      <span
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "dark-font"
                            : "light-font"
                        } flex-cnt w-[500px] text-[11px] uppercase`}
                        style={{
                          fontFamily: chatConfig?.typography?.font?.fontFamily,
                        }}
                      >
                        Chat with live agent
                      </span>
                      <hr
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "border-[#f8f8f8]"
                            : "border-[#44444421]"
                        } wd-100 border`}
                      />
                    </div>
                  );
                } else if (msg.name === "button") {
                  return (
                    <Fragment key={currentIndex}>
                      {msg.author === 0 ? (
                        <BotComponent
                          currentIndex={currentIndex}
                          chatConfig={chatConfig}
                          msg={msg}
                          embed={embed}
                          botData={botData}
                          starterQues={starterQues}
                          activeCat={activeCat}
                          handleStarterQues={handleStarterQues}
                          textColor={textColor}
                          suggestedQuesAns={suggestedQuesAns}
                          message={message}
                          setReadPdf={setReadPdf}
                          setReadPdfText={setReadPdfText}
                          handleReaction={handleReaction}
                          dataSource={dataSource}
                          userCredential={userCredential}
                          calendlyConfig={calendlyConfig}
                          handleUserReply={handleUserReply}
                          isAnswerSaved={isAnswerSaved}
                          handleRegenerate={handleRegenerate}
                          embedConfig={botData?.embedConfig}
                        />
                      ) : (
                        <UserComponent
                          currentIndex={currentIndex}
                          chatConfig={chatConfig}
                          msg={msg}
                          textColor={textColor}
                          embed={embed}
                          message={message}
                        />
                      )}
                      {!msg.hasAnswered && (
                        <div className="buttonContainer embed">
                          {msg.options
                            .sort(
                              (a, b) =>
                                (a.image?.url.length || 0) -
                                (b.image?.url.length || 0),
                            )
                            .map((value, index) => (
                              <div
                                className="questionButton flex-cnt fx-d-col gap-10"
                                key={index}
                                onClick={() => {
                                  handleButtonReply(
                                    currentIndex,
                                    value.name,
                                    index,
                                    value.value,
                                  );
                                }}
                              >
                                {msg?.showImg && value.image && (
                                  <img src={value.image.url} alt="" />
                                )}
                                <div className="option-title-wrapper flex-cnt fx-strt wd-100 gap-10">
                                  <div className="circle-radio-outer">
                                    <div className="circle-radio-inner"></div>
                                  </div>
                                  <p
                                    style={{
                                      fontFamily:
                                        chatConfig?.typography?.font
                                          ?.fontFamily,
                                      fontSize:
                                        chatConfig?.typography?.size + "px",
                                    }}
                                  >
                                    {value.name}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </Fragment>
                  );
                } else {
                  return (
                    <Fragment key={currentIndex}>
                      {msg.author === 0 ? (
                        <BotComponent
                          currentIndex={currentIndex}
                          chatConfig={chatConfig}
                          msg={msg}
                          botType={botType}
                          botData={botData}
                          starterQues={starterQues}
                          activeCat={activeCat}
                          handleStarterQues={handleStarterQues}
                          textColor={textColor}
                          suggestedQuesAns={suggestedQuesAns}
                          message={message}
                          setReadPdf={setReadPdf}
                          setReadPdfText={setReadPdfText}
                          dataSource={dataSource}
                          handleReaction={handleReaction}
                          userCredential={userCredential}
                          calendlyConfig={calendlyConfig}
                          handleUserReply={handleUserReply}
                          isAnswerSaved={isAnswerSaved}
                          handleRegenerate={handleRegenerate}
                          embedConfig={botData?.embedConfig}
                          embed={embed}
                        />
                      ) : (
                        <UserComponent
                          currentIndex={currentIndex}
                          chatConfig={chatConfig}
                          msg={msg}
                          textColor={textColor}
                          embed={embed}
                          botType={botType}
                          message={message}
                        />
                      )}
                    </Fragment>
                  );
                }
              })}
            </div>
          </div>
        </div>
        <div
          className={`footer-sec ${
            chatConfig?.theme === "dark"
              ? "dark-preview-cover-bg"
              : "light-preview-cover-bg"
          }`}
        >
          {/* {botData?.enableGemini && <VoiceCoach url={undefined} botCustomId={botData?.botCustomId} />} */}

          {showRetry && (
            <div
              className={`fx m-[20px] justify-between gap-[20px] rounded-[15px] px-[16px] py-[10px] ${
                chatConfig?.theme === "dark"
                  ? "bg-[#2F2F2F]"
                  : "border bg-[#FFEBEC] [border-color:#FF787E]"
              }`}
            >
              <div className="al-cnt grid grid-flow-col gap-[6px]">
                <svg
                  className="h-[16px] w-[16px]"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3826_34009)">
                    <path
                      d="M8.60743 0C7.02518 0 5.47846 0.469192 4.16286 1.34824C2.84727 2.22729 1.82189 3.47672 1.21639 4.93853C0.610888 6.40034 0.452461 8.00887 0.761143 9.56072C1.06982 11.1126 1.83175 12.538 2.95057 13.6569C4.06939 14.7757 5.49486 15.5376 7.0467 15.8463C8.59855 16.155 10.2071 15.9965 11.6689 15.391C13.1307 14.7855 14.3801 13.7602 15.2592 12.4446C16.1382 11.129 16.6074 9.58225 16.6074 8C16.6051 5.87897 15.7615 3.84547 14.2617 2.34568C12.762 0.845886 10.7285 0.00229405 8.60743 0ZM8.60743 14.6667C7.28888 14.6667 5.99995 14.2757 4.90362 13.5431C3.8073 12.8106 2.95281 11.7694 2.44823 10.5512C1.94364 9.33305 1.81162 7.99261 2.06886 6.6994C2.32609 5.40619 2.96103 4.21831 3.89338 3.28596C4.82573 2.35361 6.01362 1.71867 7.30682 1.46143C8.60003 1.2042 9.94048 1.33622 11.1586 1.8408C12.3768 2.34539 13.418 3.19987 14.1506 4.2962C14.8831 5.39253 15.2741 6.68146 15.2741 8C15.2722 9.76752 14.5691 11.4621 13.3193 12.7119C12.0695 13.9617 10.3749 14.6647 8.60743 14.6667Z"
                      fill="white"
                    />
                    <path
                      d="M8.60775 6.66797H7.94108C7.76427 6.66797 7.5947 6.73821 7.46968 6.86323C7.34465 6.98826 7.27441 7.15782 7.27441 7.33464C7.27441 7.51145 7.34465 7.68102 7.46968 7.80604C7.5947 7.93106 7.76427 8.0013 7.94108 8.0013H8.60775V12.0013C8.60775 12.1781 8.67799 12.3477 8.80301 12.4727C8.92803 12.5977 9.0976 12.668 9.27441 12.668C9.45123 12.668 9.62079 12.5977 9.74582 12.4727C9.87084 12.3477 9.94108 12.1781 9.94108 12.0013V8.0013C9.94108 7.64768 9.8006 7.30854 9.55056 7.05849C9.30051 6.80844 8.96137 6.66797 8.60775 6.66797Z"
                      fill="white"
                    />
                    <path
                      d="M8.60742 5.33203C9.15971 5.33203 9.60742 4.88432 9.60742 4.33203C9.60742 3.77975 9.15971 3.33203 8.60742 3.33203C8.05514 3.33203 7.60742 3.77975 7.60742 4.33203C7.60742 4.88432 8.05514 5.33203 8.60742 5.33203Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3826_34009">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.607422)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p
                  className={`text-[12px] ${
                    chatConfig?.theme === "dark"
                      ? "text-[#FFFFFF]"
                      : "text-[#FB5F66]"
                  }`}
                >
                  Network error. Check your connection and try again and contact
                  us
                </p>
              </div>
              <button
                className={`fx items-center gap-[6px] rounded-[100px] px-[12px] py-[6px] text-[12px] ${
                  chatConfig?.theme === "dark"
                    ? "bg-[#FFFFFF] text-[#000000]"
                    : "bg-[#FB5F66] text-[#FFFFFF]"
                }`}
                onClick={() => handleRegenerate(true)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.60742 2.0005C5.31642 2.0005 3.99392 2.619 3.05842 3.75H4.10742C4.24003 3.75 4.36721 3.80268 4.46098 3.89645C4.55474 3.99021 4.60742 4.11739 4.60742 4.25C4.60742 4.38261 4.55474 4.50979 4.46098 4.60355C4.36721 4.69732 4.24003 4.75 4.10742 4.75H2.10742C1.97481 4.75 1.84764 4.69732 1.75387 4.60355C1.6601 4.50979 1.60742 4.38261 1.60742 4.25L1.60742 2C1.60742 1.86739 1.6601 1.74021 1.75387 1.64645C1.84764 1.55268 1.97481 1.5 2.10742 1.5C2.24003 1.5 2.36721 1.55268 2.46098 1.64645C2.55474 1.74021 2.60742 1.86739 2.60742 2L2.60742 2.756C3.69742 1.631 5.14842 1 6.60742 1C9.36842 1 11.6064 3.2385 11.6064 6C11.6064 8.761 9.36792 11 6.60742 11C5.68969 11.0002 4.78961 10.7478 4.00582 10.2704C3.22203 9.79299 2.58479 9.10904 2.16392 8.2935C2.13236 8.23507 2.11275 8.17094 2.10624 8.10485C2.09974 8.03876 2.10646 7.97204 2.12602 7.90858C2.14558 7.84511 2.17759 7.78619 2.22018 7.73523C2.26276 7.68427 2.31507 7.64231 2.37405 7.61179C2.43303 7.58127 2.4975 7.5628 2.5637 7.55747C2.62989 7.55214 2.69648 7.56005 2.75959 7.58074C2.82269 7.60142 2.88104 7.63447 2.93124 7.67796C2.98143 7.72144 3.02246 7.77449 3.05192 7.834C3.37746 8.46519 3.86517 8.99833 4.46495 9.37864C5.06473 9.75895 5.75495 9.97271 6.4647 9.99797C7.17444 10.0232 7.87811 9.85907 8.50341 9.52236C9.12871 9.18564 9.65309 8.68852 10.0227 8.08207C10.3922 7.47562 10.5937 6.7817 10.6063 6.07162C10.619 5.36154 10.4423 4.6609 10.0945 4.04169C9.74674 3.42248 9.24037 2.90703 8.62743 2.5483C8.0145 2.18957 7.31711 2.00049 6.60692 2.0005H6.60742Z"
                    fill="black"
                  />
                </svg>
                Retry
              </button>
            </div>
          )}
          <div className="branding">
            <div
              style={{
                opacity: disableInput || islast || overLimit ? "0.3" : "1",
              }}
              className={`user-container-preview embed !rounded-[100px] border ${
                chatConfig?.theme === "dark"
                  ? "border border-white/80 bg-[#222] text-[#fff]"
                  : "bg-[#EEE] text-[#444]"
              }`}
            >
              <input
                className={`userInput height__52 !bg-transparent ${
                  chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                }`}
                type="text"
                style={{ fontFamily: chatConfig?.typography?.font?.fontFamily }}
                placeholder="Compose your message...."
                autoFocus
                value={newReply}
                onChange={handleButtomInput}
                onKeyDown={(e) =>
                  e.keyCode === 13 &&
                  !e.shiftKey &&
                  !responseLoader &&
                  handleSendReplyButton(e)
                }
                readOnly={disableInput || islast || overLimit}
                ref={userInputRef}
              />
              <div
                className={`suggested-cta flex-cnt ${
                  !botData?.aiStarterQues?.data.length ? "none" : ""
                } ${
                  message[message.length - 1]?.text?.isMandatory
                    ? "opacity-30"
                    : ""
                }`}
              >
                <div
                  onClick={() => {
                    setSuggestedQuesAns(true);
                    setStarterQues(botData?.aiStarterQues?.data);
                  }}
                >
                  <SuggestedQuesAns />
                </div>
              </div>
              <div className="userBtn"></div>
              <div className="userBtn embed__send">
                <div
                  className="svg-box m-right-8 d !rounded-[100px]"
                  style={{
                    background: `${
                      botData?.embedConfig?.chatWithUsIconConfig?.bgColor
                    }`,
                  }}
                  onClick={() =>
                    responseLoader ? handleStop() : handleSendReplyButton()
                  }
                >
                  <span
                    style={{
                      color: `${
                        chatConfig?.botBubbleColor === "#F1F1F1"
                          ? "#fff"
                          : textColor
                      }`,
                      fontFamily: chatConfig?.typography?.font?.fontFamily,
                    }}
                  >
                    {responseLoader ? (
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.607422"
                          y="0.5"
                          width="14"
                          height="14"
                          rx="4"
                          fill="white"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                      >
                        <path
                          d="M1.12457 0.888736L15.5045 8.07234C15.7365 8.18823 15.8318 8.47283 15.7175 8.70801C15.6719 8.80185 15.597 8.87778 15.5045 8.92402L1.12487 16.1075C0.892888 16.2234 0.612165 16.1267 0.497855 15.8915C0.447871 15.7886 0.436284 15.6709 0.465235 15.5601L1.88993 10.1057C1.93705 9.92536 2.08403 9.78969 2.26558 9.759L8.70978 8.66968C8.78873 8.65634 8.85401 8.6035 8.88538 8.53167L8.90224 8.47457C8.92046 8.36373 8.85976 8.25804 8.76172 8.21654L8.70978 8.20141L2.22919 7.10639C2.04757 7.0757 1.90054 6.93995 1.85347 6.75949L0.46491 1.436C0.398763 1.18253 0.547815 0.922697 0.797827 0.855636C0.907113 0.826322 1.02317 0.838079 1.12457 0.888736Z"
                          fill="white"
                        />
                      </svg>
                    )}
                  </span>
                </div>
              </div>
            </div>

            {!isReplyValid && showError && error !== "Field is required" && (
              <span className="small-txt error p-left no-m-tb">{error}</span>
            )}
            {checkValidate && (
              <span className="small-txt error p-left no-m-tb">{error}</span>
            )}
            {/* <div
              className={`skip-check wd-50 ${
                !environmentData?.isAI ? "omni-no-skip" : " "
              }`}
              style={{
                justifyContent:
                  botData?.emailConsent &&
                  (questions[currentQuestionIndex ?? 0]?.name === "email" ||
                    message[message.length - 1]?.name === "email")
                    ? ""
                    : "flex-end",
              }}
            >
              {botData?.emailConsent &&
                isSkip.current &&
                (questions[currentQuestionIndex ?? 0]?.name === "email" ||
                  message[message.length - 1]?.name === "email") && (
                  <div className="gdpr-checkbox">
                    <label className="agree">
                      <input
                        type="checkbox"
                        checked={emailCheck}
                        onChange={(e) => handleButtomInput(e, true)}
                      />
                      <div
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "dark-font"
                            : "light-font"
                        }`}
                      >
                        {botData?.emailConsentContent}
                      </div>

                      <span className={`checkmark check-embed checkmark-dark`}>
                        <svg
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0002 1.85403L4.80016 11.25L0.583496 6.94351L1.6645 5.83949L4.80016 9.03412L12.9192 0.75L14.0002 1.85403Z"
                            fill="white"
                          ></path>
                        </svg>
                      </span>
                    </label>
                    {!isReplyValid &&
                      showError &&
                      error === "Field is required" && (
                        <span className="checkbox-error">{error}</span>
                      )}
                  </div>
                )}

              {environmentData?.isAI &&
                ((message[message.length - 1]?.name === "ask_question" &&
                  message[message.length - 1]?.text?.value &&
                  isSkip.current) ||
                  (message[message.length - 1]?.name === "email" &&
                    isSkip.current) ||
                  (message[message.length - 1]?.name === "phone" &&
                    isSkip.current)) &&
                !message[message.length - 1]?.text?.isMandatory && (
                  <button
                    style={{
                      color: `${
                        chatConfig?.botBubbleColor === "#F1F1F1" ? "#fff" : textColor
                      }`,
                      fontFamily: chatConfig?.typography?.font?.fontFamily,
                      background: `${
                        chatConfig?.botBubbleColor === "#F1F1F1" ? "" : chatConfig?.botBubbleColor
                      }`,
                    }}
                    className="skip-btn"
                    onClick={handleSkipButton}
                  >
                    {" "}
                    Skip
                  </button>
                )}
            </div> */}
          </div>
          {botData?.cookieConsent && consent && (
            <div
              className={`cookieConsent cookie-popup ${
                chatConfig?.theme === "dark" ? "dark-bg" : "light-bg"
              }`}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: botData?.cookieConsentContent,
                }}
                className={`cookieConsent-inner ${
                  chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                }`}
              />
              <div
                className={`btn btn-popup ${
                  chatConfig?.theme === "dark" ? "dark-bg" : "light-bg"
                }`}
              >
                <button
                  className={` ${
                    chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                  }`}
                  onClick={() => {
                    setConsent(false);
                    setCookie("privacy_policy", true);
                  }}
                >
                  Accept
                </button>
                <button
                  className={` ${
                    chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                  }`}
                  onClick={() => {
                    setConsent(false);
                    deleteCookies("privacy_policy");
                  }}
                >
                  Decline
                </button>
              </div>
            </div>
          )}
          {/* {chatConfig?.omniBranding && (
            <div className="flex-cnt">
              <div
                className={`logo-signature logo-embed ${
                  chatConfig?.theme === "dark" ? "dark-bg" : " "
                }`}
              >
                <span
                  className={`${
                    chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                  }`}
                >
                  Powered By
                </span>
                {environmentData?.isAI ? (
                  <BrandingLogoCBB />
                ) : (
                  <BrandingLogoOmni />
                )}
                <span
                  className={`${
                    chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                  } cp`}
                  onClick={() =>
                    window.open(
                      environmentData?.isAI
                        ? "https://chatbotbuilder.net"
                        : "https://omniengage.co",
                      "_blank",
                    )
                  }
                >
                  {environmentData?.isAI ? "ChatBot Builder" : "Omniengage"}
                </span>
              </div>
            </div>
          )} */}
        </div>
      </div>
    );
  }

  return (
    <div className="full-screen-mobile">
      <div
        className={`preview-container-main in-page live-bot ${
          chatConfig?.theme === "dark"
            ? "dark-preview-cover-bg"
            : "light-preview-cover-bg"
        }`}
      >
        {environment === "dev" && (
          <div
            className={`preview-head ${
              chatConfig?.theme === "dark" ? "dark-bg" : "light-bg"
            }`}
          >
            <h1
              className={`${
                chatConfig?.theme === "dark" ? "dark-font" : "light-font"
              }`}
            >
              {" "}
              {botName}{" "}
            </h1>
            <div className="right-head-preview">
              <button
                className="close-preview-button"
                onClick={() => router(-1)}
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.91615 5.00779L9.80995 1.11387C10.0634 0.860582 10.0634 0.451058 9.80995 0.197775C9.55667 -0.0555083 9.14715 -0.0555083 8.89386 0.197775L4.99994 4.09169L1.10614 0.197775C0.85274 -0.0555083 0.443335 -0.0555083 0.190051 0.197775C-0.0633505 0.451058 -0.0633505 0.860582 0.190051 1.11387L4.08385 5.00779L0.190051 8.90171C-0.0633505 9.15499 -0.0633505 9.56451 0.190051 9.8178C0.316278 9.94414 0.482247 10.0076 0.648097 10.0076C0.813947 10.0076 0.979797 9.94414 1.10614 9.8178L4.99994 5.92388L8.89386 9.8178C9.02021 9.94414 9.18606 10.0076 9.35191 10.0076C9.51776 10.0076 9.68361 9.94414 9.80995 9.8178C10.0634 9.56451 10.0634 9.15499 9.80995 8.90171L5.91615 5.00779Z"
                    fill="#FB5F66"
                  />
                </svg>
                Close Preview
              </button>
            </div>
          </div>
        )}
        <div
          className={`embed-header no-radius ${
            chatConfig?.theme === "dark" ? "dark-bg" : "light-preview-cover-bg"
          } `}
        >
          {chatConfig?.logo ? (
            <img src={chatConfig?.logo} alt="boticon" />
          ) : chatConfig?.theme === "dark" ? (
            <WhiteBotIcon />
          ) : (
            <BotIconOld />
          )}
          <div className="embed-header-desc">
            <h3
              className={`${
                chatConfig?.theme === "dark" ? "dark-font" : "light-font"
              }`}
              style={{
                fontFamily: chatConfig?.typography?.font?.fontFamily,
              }}
            >
              {" "}
              {chatConfig?.headerName}
            </h3>
            {chatConfig?.showHeaderDesc && (
              <p
                className={`${
                  chatConfig?.theme === "dark" ? "dark-font op-7" : "light-font"
                }`}
                style={{ fontFamily: chatConfig?.typography?.font?.fontFamily }}
              >
                {chatConfig?.headerDescription}
              </p>
            )}{" "}
          </div>
        </div>
        <div
          className="previewContainer new-scrollbar embed fx-d-col"
          ref={scrollRef}
        >
          <div className="centered-div">
            <div className="chatDataContainer">
              {message?.map((msg, currentIndex) => {
                if (msg.name === "agent-start") {
                  return (
                    <div className="wd-100 flex items-center gap-[15px]">
                      <hr
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "border-[#f8f8f8]"
                            : "border-[#44444421]"
                        } wd-100 border`}
                      />
                      <span
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "dark-font"
                            : "light-font"
                        } flex-cnt w-[500px] text-[11px] uppercase`}
                        style={{
                          fontFamily: chatConfig?.typography?.font?.fontFamily,
                        }}
                      >
                        Chat with live agent
                      </span>
                      <hr
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "border-[#f8f8f8]"
                            : "border-[#44444421]"
                        } wd-100 border`}
                      />
                    </div>
                  );
                } else if (msg.name === "button") {
                  return (
                    <div key={currentIndex} className="gid gap-[10px]">
                      {msg.author === 0 ? (
                        <BotComponent
                          currentIndex={currentIndex}
                          chatConfig={chatConfig}
                          msg={msg}
                          embed={embed}
                          botData={botData}
                          starterQues={starterQues}
                          activeCat={activeCat}
                          handleStarterQues={handleStarterQues}
                          textColor={textColor}
                          suggestedQuesAns={suggestedQuesAns}
                          message={message}
                          setReadPdf={setReadPdf}
                          setReadPdfText={setReadPdfText}
                          dataSource={dataSource}
                          handleReaction={handleReaction}
                          userCredential={userCredential}
                          calendlyConfig={calendlyConfig}
                          handleUserReply={handleUserReply}
                          isAnswerSaved={isAnswerSaved}
                          handleRegenerate={handleRegenerate}
                        />
                      ) : (
                        <UserComponent
                          currentIndex={currentIndex}
                          chatConfig={chatConfig}
                          msg={msg}
                          textColor={textColor}
                          embed={embed}
                          message={message}
                        />
                      )}
                      {!msg.hasAnswered && (
                        <div className="buttonContainer">
                          {msg.options
                            .sort(
                              (a, b) =>
                                (a.image?.url.length || 0) -
                                (b.image?.url.length || 0),
                            )
                            .map((value, index) => (
                              <div
                                className="questionButton flex-cnt fx-d-col gap-10"
                                key={index}
                                onClick={() => {
                                  handleButtonReply(
                                    currentIndex,
                                    value.name,
                                    index,
                                    value.value,
                                  );
                                }}
                              >
                                {msg?.showImg && value.image && (
                                  <img src={value.image.url} alt="" />
                                )}
                                <div className="option-title-wrapper flex-cnt fx-strt wd-100 gap-10">
                                  <div className="circle-radio-outer">
                                    <div className="circle-radio-inner"></div>
                                  </div>
                                  <p
                                    style={{
                                      fontFamily:
                                        chatConfig?.typography?.font
                                          ?.fontFamily,
                                      fontSize:
                                        chatConfig?.typography?.size + "px",
                                    }}
                                  >
                                    {value.name}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <Fragment key={currentIndex}>
                      <div className="grid gap-[10px]">
                        {msg.author === 0 ? (
                          <BotComponent
                            botData={botData}
                            currentIndex={currentIndex}
                            chatConfig={chatConfig}
                            msg={msg}
                            starterQues={starterQues}
                            activeCat={activeCat}
                            handleStarterQues={handleStarterQues}
                            textColor={textColor}
                            suggestedQuesAns={suggestedQuesAns}
                            message={message}
                            setReadPdf={setReadPdf}
                            setReadPdfText={setReadPdfText}
                            dataSource={dataSource}
                            handleReaction={handleReaction}
                            userCredential={userCredential}
                            calendlyConfig={calendlyConfig}
                            handleUserReply={handleUserReply}
                            isAnswerSaved={isAnswerSaved}
                            handleRegenerate={handleRegenerate}
                          />
                        ) : (
                          <UserComponent
                            currentIndex={currentIndex}
                            chatConfig={chatConfig}
                            msg={msg}
                            textColor={textColor}
                            embed={embed}
                            botType={botType}
                            message={message}
                          />
                        )}
                      </div>
                    </Fragment>
                  );
                }
              })}
            </div>
          </div>

          {/* // StarterQuestion Section     */}
          {/* <div className="preview-starter-ques"> */}
          {/* {botData && starterQues && (
              <h4
                className={`${chatConfig?.theme === "dark" ? "dark-font" : "light-font"}`}
                style={{ fontSize: typography?.size + "px", fontFamily: typography?.font?.fontFamily }}
              >
                SUGGESTED QUESTIONS
              </h4>
            )} */}
          {/* <ul>
              {botData &&
                starterQues &&
                botData?.aiStarterQues?.initialMsg?.trim().length > 0 &&
                (!activeCat && botData?.aiStarterQues?.isCat
                  ? botData?.aiStarterQues?.cats.map((cat) => {
                      return (
                        <li
                          onClick={() => {
                            handleStarterQues(cat);
                          }}
                          style={{ fontSize: typography?.size + "px", fontFamily: typography?.font?.fontFamily }}
                        >
                          {cat}
                        </li>
                      );
                    })
                  : starterQues?.map((item) => {
                      return (
                        <li
                          onClick={() => {
                            handleStarterQues(item?.ques);
                          }}
                          style={{ fontSize: typography?.size + "px", fontFamily: typography?.font?.fontFamily }}
                        >
                          {item?.ques}
                        </li>
                      );
                    }))}
            </ul> */}
          {/* {activeCat && <UserComponent chatConfig={chatConfig} msg={activeCat} textColor={textColor} embed={embed} />} */}
          {/* </div> */}
        </div>
        {/* {environmentData?.isAI &&
          chatHandler === "ai" &&
          message?.length > 1 && (
            // message[message.length - 1]?.aiResponse && (
          //  <button
          //     className={`stop-rgn-btn ${
          //       chatConfig?.theme === "dark" ? "stop-rgn-btn-dark gg" : ""
          //     } ${botData?.enableGemini ? "!mb-[18px]" : ""} `}
          //     onClick={() =>
          //       responseLoader
          //         ? handleStop()
          //         : handleRegenerate(message.at(-1).author == ai)
          //     }
          //   >
          //     {responseLoader
          //       ? "Stop" 
          //       : message.at(-1).author == ai
          //         ? "Regenerate"
          //         : "Retry"}
          //   </button>
          )} */}
        <div className="footer-sec">
          <div
            className={`wd-50 branding ${
              chatConfig?.theme === "dark" ? " " : " "
            }`}
          >
            {botData?.enableGemini && (
              <VoiceCoach url={undefined} botCustomId={botData?.botCustomId} />
            )}
            <div
              style={{
                opacity: disableInput || islast || overLimit ? "0.3" : "1",
              }}
              className={`user-container-preview wd-50 embed in-page-test !items-center ${
                chatConfig?.theme === "dark"
                  ? "dark-font dark-border focus-dark dark-preview-cover-bg"
                  : "light-font light-border focus-light bg-white"
              }`}
            >
              <input
                ref={inputRef}
                className={`userInput forMobile textBox !bg-transparent ${
                  chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                }`}
                style={{ fontFamily: chatConfig?.typography?.font?.fontFamily }}
                placeholder="Compose your message...."
                autoFocus
                onFocus={() =>
                  document.addEventListener("touchmove", onTouchMove)
                }
                onBlur={() =>
                  document.removeEventListener("touchmove", onTouchMove)
                }
                value={newReply}
                onChange={handleButtomInput}
                onKeyDown={(e) =>
                  e.keyCode === 13 &&
                  !e.shiftKey &&
                  !responseLoader &&
                  handleSendReplyButton(e)
                }
                readOnly={disableInput || islast || overLimit}
              />
              <textarea
                className={`userInput forWeb textBox !bg-transparent ${
                  chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                }`}
                style={{ fontFamily: chatConfig?.typography?.font?.fontFamily }}
                placeholder="Compose your message...."
                autoFocus
                // onTouchStart={(e) => disableScrolling(e.target)}
                // onFocus={(e) => disableScrolling(e.target)}
                // onBlur={enableScrolling}
                value={newReply}
                onChange={handleButtomInput}
                onKeyDown={(e) =>
                  e.keyCode === 13 &&
                  !e.shiftKey &&
                  !responseLoader &&
                  handleSendReplyButton(e)
                }
                readOnly={disableInput || islast || overLimit}
              />
              <div
                className={`suggested-cta flex-cnt mb-12 ${
                  !botData?.aiStarterQues?.data.length ? "none" : ""
                } ${
                  message[message.length - 1]?.text?.isMandatory
                    ? "opacity-30"
                    : ""
                }`}
              >
                <div
                  onClick={() => {
                    setSuggestedQuesAns(true);
                    setStarterQues(botData?.aiStarterQues?.data);
                  }}
                >
                  <SuggestedQuesAns />
                </div>
              </div>
              <div className="userBtn btn-text-area">
                <div
                  className="svg-box"
                  style={{
                    background: `${
                      chatConfig?.botBubbleColor === "#F1F1F1"
                        ? ""
                        : chatConfig?.botBubbleColor
                    }`,
                  }}
                  onClick={() => !responseLoader && handleSendReplyButton()}
                >
                  <span
                    style={{
                      color: `${
                        chatConfig?.botBubbleColor === "#F1F1F1"
                          ? "#fff"
                          : textColor
                      }`,
                      fontFamily: chatConfig?.typography?.font?.fontFamily,
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                      fill="none"
                    >
                      <path
                        d="M0.726995 0.829519L14.6365 7.77814C14.8609 7.89024 14.9532 8.16553 14.8426 8.39302C14.7985 8.48379 14.726 8.55724 14.6365 8.60197L0.72728 15.5504C0.502888 15.6625 0.231346 15.569 0.120776 15.3415C0.0724268 15.242 0.0612189 15.1282 0.0892228 15.021L1.46732 9.74503C1.51289 9.57055 1.65506 9.43932 1.83068 9.40963L8.06409 8.35595C8.14045 8.34304 8.2036 8.29193 8.23394 8.22245L8.25025 8.16721C8.26788 8.06 8.20916 7.95778 8.11433 7.91763L8.06409 7.90299L1.79548 6.84379C1.6198 6.81411 1.47758 6.6828 1.43205 6.50824L0.0889088 1.35888C0.0249249 1.11371 0.169101 0.862369 0.410936 0.797502C0.516647 0.769147 0.628908 0.780519 0.726995 0.829519Z"
                        fill="white"
                      />
                    </svg>
                  </span>

                  {/* <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.218874 15.2698C0.0874003 15.8739 0.551255 16.1297 0.981657 15.9367L15.5282 8.47782H15.5296C15.7031 8.37995 15.8039 8.2036 15.8039 8.00016C15.8039 7.79661 15.7031 7.62014 15.5296 7.52231H15.5282L0.981657 0.0632796C0.551255 -0.12972 0.0874003 0.12611 0.218874 0.730295C0.22777 0.77122 1.08775 4.6019 1.55532 6.68527L9.14883 8.00012L1.55532 9.31482C1.08775 11.3981 0.227731 15.2288 0.218874 15.2698Z"
                  fill={botType === "web" || chatConfig?.botBubbleColor === "#F1F1F1" ? "#fff" : textColor}
                />
              </svg> */}
                </div>
              </div>
            </div>

            {!isReplyValid && showError && error !== "Field is required" && (
              <span className="small-txt error check-error no-m-tb mt-10">
                {error}
              </span>
            )}

            {/* {checkValidate && <span className="small-txt error p-left no-m-tb">{error}</span>} */}

            {/* <div
              className={`skip-check wd-50 ${
                !environmentData?.isAI ? "omni-no-skip" : ""
              }`}
              style={{
                justifyContent:
                  botData?.emailConsent &&
                  (questions[currentQuestionIndex ?? 0]?.name === "email" ||
                    message[message.length - 1]?.name === "email")
                    ? ""
                    : "flex-end",
              }}
            >
              {botData?.emailConsent &&
                isSkip.current &&
                (questions[currentQuestionIndex ?? 0]?.name === "email" ||
                  message[message.length - 1]?.name === "email") && (
                  <div className="gdpr-checkbox">
                    <label className="agree">
                      <div
                        className={`${
                          chatConfig?.theme === "dark"
                            ? "dark-font"
                            : "light-font"
                        }`}
                        style={{
                          fontFamily: chatConfig?.typography?.font?.fontFamily,
                        }}
                      >
                        {botData?.emailConsentContent}
                      </div>
                      <input
                        type="checkbox"
                        checked={emailCheck}
                        onChange={(e) => handleButtomInput(e, true)}
                      />
                      <span className={`checkmark checkmark-dark`}>
                        <svg
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0002 1.85403L4.80016 11.25L0.583496 6.94351L1.6645 5.83949L4.80016 9.03412L12.9192 0.75L14.0002 1.85403Z"
                            fill="white"
                          ></path>
                        </svg>
                      </span>
                    </label>
                    {!isReplyValid &&
                      showError &&
                      error === "Field is required" && (
                        <span className="checkbox-error">{error}</span>
                      )}
                  </div>
                )}

              {environmentData?.isAI &&
                ((message[message.length - 1]?.name === "ask_question" &&
                  message[message.length - 1]?.text?.value &&
                  isSkip.current) ||
                  (message[message.length - 1]?.name === "email" &&
                    isSkip.current) ||
                  (message[message.length - 1]?.name === "phone" &&
                    isSkip.current)) &&
                !message[message.length - 1]?.text?.isMandatory && (
                  <button
                    style={{
                      // border: `${chatConfig?.theme === "dark" ? "1px solid #EDEDED" : "1px solid #FB5F66"}`,
                      color: `${
                        chatConfig?.botBubbleColor === "#F1F1F1" ? "#fff" : textColor
                      }`,
                      fontFamily: chatConfig?.typography?.font?.fontFamily,
                      background: `${
                        chatConfig?.botBubbleColor === "#F1F1F1" ? "" : chatConfig?.botBubbleColor
                      }`,
                    }}
                    className="skip-btn"
                    onClick={handleSkipButton}
                  >
                    {" "}
                    Skip
                  </button>
                )}
            </div> */}
          </div>

          {botData?.cookieConsent && consent && (
            <div
              className={`cookieConsent ${
                chatConfig?.theme === "dark" ? "dark-bg" : "light-bg"
              }`}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: botData?.cookieConsentContent,
                }}
                className={`cookieConsent-inner ${
                  chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                }`}
              />
              <div
                className={`btn ${
                  chatConfig?.theme === "dark" ? "dark-bg" : "light-bg"
                }`}
              >
                <button
                  className={` ${
                    chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                  }`}
                  onClick={() => {
                    setConsent(false);
                    setCookie("privacy_policy", true);
                  }}
                >
                  Accept
                </button>
                <button
                  className={` ${
                    chatConfig?.theme === "dark" ? "dark-font" : "light-font"
                  }`}
                  onClick={() => {
                    setConsent(false);
                    deleteCookies("privacy_policy");
                  }}
                >
                  Decline
                </button>
              </div>
            </div>
          )}
          {/* {chatConfig?.omniBranding && (
            <div className="flex-cnt">
              <div className={`logo-signature logo-embed ${chatConfig?.theme === "dark" ? "dark-bg" : " "}`}>
                <span className={`${chatConfig?.theme === "dark" ? "dark-font" : "light-font"}`}>Powered By</span>
                {environmentData?.isAI ? <BrandingLogoCBB /> : <BrandingLogoOmni />}
                <span className={`${chatConfig?.theme === "dark" ? "dark-font" : "light-font"}`}>
                 {environmentData?.isAI ? "ChatBot Builder" : "Omniengage"}{" "}
                </span>
                
              </div>
              
            </div>
          )} */}
          {showNotification && (
            <div className="preview-toast">
              <img
                src="https://res.cloudinary.com/dnag1wvx8/image/upload/v1663831594/image_92_vidzl7.png"
                alt=""
              />
              <div className="toast-content">
                <h1>
                  {notificationData && notificationData.title
                    ? notificationData.title
                    : ""}
                </h1>
                <p
                  dangerouslySetInnerHTML={{
                    __html: notificationData?.body
                      ? notificationData?.body
                      : "",
                  }}
                ></p>
              </div>
              <div
                className="cross-mark"
                onClick={() => setShowNotification(false)}
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.95839 5.07389C5.94869 5.06421 5.94099 5.05272 5.93574 5.04006C5.93049 5.02741 5.92778 5.01384 5.92778 5.00014C5.92778 4.98644 5.93049 4.97287 5.93574 4.96022C5.94099 4.94756 5.94869 4.93607 5.95839 4.92639L9.81797 1.06722C9.93516 0.949864 10.0009 0.790758 10.0008 0.624906C10.0007 0.459053 9.9347 0.30004 9.81735 0.182848C9.69999 0.0656552 9.54088 -0.000117052 9.37503 1.56384e-07C9.20918 0.000117365 9.05016 0.0661144 8.93297 0.183473L5.0738 4.04097C5.06413 4.05067 5.05263 4.05837 5.03998 4.06362C5.02732 4.06887 5.01375 4.07158 5.00005 4.07158C4.98635 4.07158 4.97278 4.06887 4.96013 4.06362C4.94747 4.05837 4.93598 4.05067 4.9263 4.04097L1.06714 0.183473C1.00911 0.125418 0.940214 0.0793602 0.864387 0.0479305C0.788559 0.0165007 0.707283 0.00031412 0.6252 0.000294775C0.459426 0.000255705 0.300426 0.0660718 0.183178 0.183264C0.0659302 0.300457 3.90875e-05 0.459426 1.73848e-08 0.6252C-3.90527e-05 0.790975 0.0657771 0.949975 0.18297 1.06722L4.04172 4.92639C4.05142 4.93607 4.05912 4.94756 4.06437 4.96022C4.06962 4.97287 4.07232 4.98644 4.07232 5.00014C4.07232 5.01384 4.06962 5.02741 4.06437 5.04006C4.05912 5.05272 4.05142 5.06421 4.04172 5.07389L0.18297 8.93347C0.124942 8.99153 0.078917 9.06044 0.047523 9.13629C0.016129 9.21213 -1.93282e-05 9.29341 1.73848e-08 9.37549C3.90875e-05 9.54127 0.0659302 9.70024 0.183178 9.81743C0.241233 9.87546 0.310149 9.92148 0.385992 9.95288C0.461834 9.98427 0.543117 10.0004 0.6252 10.0004C0.790975 10.0004 0.949944 9.93447 1.06714 9.81722L4.9263 5.95764C4.93598 5.94794 4.94747 5.94024 4.96013 5.93499C4.97278 5.92974 4.98635 5.92704 5.00005 5.92704C5.01375 5.92704 5.02732 5.92974 5.03998 5.93499C5.05263 5.94024 5.06413 5.94794 5.0738 5.95764L8.93297 9.81722C9.05016 9.93447 9.20913 10.0004 9.37491 10.0004C9.54068 10.0004 9.69968 9.93462 9.81693 9.81743C9.93418 9.70024 10.0001 9.54127 10.0001 9.37549C10.0001 9.20972 9.93433 9.05072 9.81714 8.93347L5.95839 5.07389Z"
                    fill="#6D6D6D"
                  />
                </svg>
              </div>
            </div>
          )}
        </div>
        {chatConfig?.omniBranding && (
          <div
            className={`logo-signature ${
              chatConfig?.theme === "dark" ? "dark-bg" : "light-bg"
            }`}
          >
            <span
              className={`${
                chatConfig?.theme === "dark" ? "dark-font" : "light-font"
              }`}
            >
              Powered By
            </span>
            {environmentData?.isAI ? <BrandingLogoCBB /> : <BrandingLogoOmni />}
            <span
              className={`${
                chatConfig?.theme === "dark" ? "dark-font" : "light-font"
              }`}
            >
              <a
                href={
                  environmentData?.isAI
                    ? "https://chatbotbuilder.net"
                    : "https://omniengage.co"
                }
              >
                {environmentData?.isAI ? "ChatBot Builder" : "Omniengage"}
              </a>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default Preview;

interface Row {
  key: string;
  value: any;
  testValue: string;
}

const BrandingLogoOmni = () => (
  <svg
    width={29}
    height={28}
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2085_10186)">
      <path
        d="M22.718 10.8422C23.9774 10.2899 25.4734 10.8631 25.7644 12.2072C26.2009 14.2231 26.1325 16.3294 25.5467 18.3341C24.7263 21.1414 22.9439 23.5701 20.512 25.1947C18.0802 26.8192 15.154 27.5357 12.2466 27.2186C9.33926 26.9015 6.63632 25.571 4.61181 23.4605C2.58729 21.3499 1.37036 18.594 1.17446 15.676C0.978559 12.758 1.81617 9.86416 3.54041 7.50188C5.26467 5.13965 7.7655 3.4598 10.6044 2.75699C12.6317 2.25504 14.7391 2.27424 16.7351 2.79422C18.0659 3.14088 18.5764 4.65938 17.9722 5.89478C17.368 7.13012 15.867 7.59383 14.502 7.42712C13.606 7.31773 12.6908 7.37075 11.8012 7.591C10.0979 8.01272 8.59739 9.02061 7.56286 10.438C6.52828 11.8553 6.02575 13.5916 6.14327 15.3424C6.26079 17.0932 6.99094 18.7468 8.20566 20.0131C9.42037 21.2794 11.0421 22.0777 12.7865 22.268C14.531 22.4583 16.2867 22.0283 17.7458 21.0536C19.2049 20.0789 20.2744 18.6216 20.7665 16.9373C21.0236 16.0577 21.1147 15.1455 21.0426 14.2457C20.9328 12.8749 21.4586 11.3944 22.718 10.8422Z"
        fill="#FB5F66"
      />
      <path
        d="M27.2799 6.87081C26.8448 7.21147 25.5525 6.72189 24.1552 6.07874C23.0413 6.50435 22.321 6.26301 23.8277 7.88542C24.9258 9.06768 21.7416 8.92601 19.9035 10.7641C17.5372 13.2177 18.5705 18.7253 15.6631 14.1324C14.5676 12.4018 16.1237 17.6853 15.3855 17.9002C14.4066 18.065 14.5265 16.8718 14.1757 14.0777C14.0084 12.7458 13.8104 13.9541 13.5726 15.4165C14.59 17.8493 14.2542 16.2574 13.5286 17.139L13.3172 16.8999C13.1407 17.8116 12.9453 18.494 12.7283 18.2771C12.2273 17.7759 11.721 15.1833 11.0408 14.3259L10.9492 14.2224C10.9801 14.2533 11.0106 14.2879 11.0408 14.3259L13.3172 16.8999C13.4072 16.4354 13.4922 15.9114 13.5726 15.4165C13.2627 14.6752 12.827 13.5602 12.2385 11.8877C11.6122 9.40722 15.8552 10.8004 17.5817 9.42265C19.3083 8.04494 19.9668 6.25264 19.6963 4.42994C19.7303 3.80576 22.0608 5.11479 24.1552 6.07874C24.5117 5.94249 24.9085 5.73797 25.2856 5.38205C25.5541 5.12852 25.7666 4.85554 25.9041 4.56289L23.5358 0.590332C25.914 2.17858 26.4033 3.50021 25.9041 4.56289L27.2799 6.87081Z"
        fill="#444444"
      />
      <path
        d="M26.8215 1.85207C25.0928 0.123352 22.29 0.123353 20.5613 1.85207C18.8326 3.58079 18.8326 6.38359 20.5613 8.11231C22.29 9.84103 25.0928 9.84103 26.8215 8.11231C28.5502 6.38359 28.5502 3.58079 26.8215 1.85207Z"
        fill="#444444"
      />
      <path
        d="M17.51 11.1642C15.4356 9.08974 12.0722 9.08974 9.99776 11.1642C7.9233 13.2387 7.9233 16.602 9.99776 18.6765C12.0722 20.7509 15.4356 20.7509 17.51 18.6765C19.5845 16.602 19.5845 13.2387 17.51 11.1642Z"
        fill="#444444"
      />
    </g>
    <defs>
      <clipPath id="clip0_2085_10186">
        <rect
          width={27.6862}
          height={27.6862}
          fill="white"
          transform="translate(0.701172)"
        />
      </clipPath>
    </defs>
  </svg>
);

const BrandingLogoCBB = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2374 7.32417L11.2362 7.34163V7.35914C11.2362 7.89245 11.1281 8.22884 10.9809 8.44996C10.8369 8.6663 10.6214 8.82361 10.3049 8.93664C9.97956 9.05282 9.56787 9.11458 9.06559 9.14387C8.62435 9.1696 8.14337 9.16916 7.61923 9.16868C7.54762 9.16862 7.47522 9.16855 7.40199 9.16855C7.32877 9.16855 7.25636 9.16862 7.18476 9.16868C6.66062 9.16916 6.17964 9.1696 5.7384 9.14387C5.23612 9.11458 4.82442 9.05282 4.49909 8.93664C4.18261 8.82361 3.96708 8.6663 3.82306 8.44996C3.67585 8.22884 3.56776 7.89245 3.56776 7.35914C3.56776 5.2349 5.291 3.48182 7.40199 3.48182C9.55907 3.48182 11.3861 5.13159 11.2374 7.32417Z"
      stroke="#444444"
      strokeWidth="1.03395"
    />

    <path
      d="M2.75549 3.99891C-0.0153649 8.08562 2.67627 11.0943 4.85986 10.9699C4.91074 10.967 4.95452 11.0067 4.95452 11.0576V12.9632C4.95452 13.0406 5.04861 13.0787 5.10251 13.0232L7.04553 11.0213C7.08165 10.9841 7.13302 10.9652 7.18471 10.9695C9.88113 11.1931 12.0041 10.6999 12.7894 9.15648C13.7737 7.22207 12.8324 4.84835 11.8847 3.81439C9.9029 1.05719 4.95449 0.755614 2.75549 3.99891Z"
      stroke="url(#paint0_linear_2541_12675)"
      strokeWidth="1.20628"
    />
    <ellipse
      cx="5.81734"
      cy="6.6689"
      rx="0.540974"
      ry="0.540973"
      fill="#FB5F66"
    />
    <ellipse
      cx="7.44039"
      cy="6.6689"
      rx="0.540974"
      ry="0.540973"
      fill="#FB5F66"
    />
    <ellipse
      cx="9.06343"
      cy="6.6689"
      rx="0.540974"
      ry="0.540973"
      fill="#FB5F66"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2541_12675"
        x1="3.35457"
        y1="1.91882"
        x2="7.26257"
        y2="13.1757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF898E" />
        <stop offset="0.546875" stopColor="#EA0D17" />
        <stop offset="1" stopColor="#FB5F66" />
      </linearGradient>
    </defs>
  </svg>
);

const SuggestedQuesAns = () => (
  <svg
    className="cp"
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M7.08984 15.8789C7.49637 15.8789 7.87699 15.7788 8.22117 15.6138C7.88461 15.2699 7.88514 14.7196 8.22621 14.3786C8.56729 14.0375 9.11754 14.037 9.46143 14.3735C9.62648 14.0293 9.72656 13.6487 9.72656 13.2422C9.72656 11.7882 8.54379 10.6055 7.08984 10.6055C5.6359 10.6055 4.45312 11.7882 4.45312 13.2422C4.45312 14.6961 5.6359 15.8789 7.08984 15.8789Z"
      fill="#7A7A7A"
    />
    <path
      d="M2.69531 22.9102H3.57422V23.7891C3.57422 24.274 3.18023 24.668 2.69531 24.668C2.20951 24.668 1.81641 25.0611 1.81641 25.5469C1.81641 26.0327 2.20951 26.4258 2.69531 26.4258H4.45312C6.57574 26.4258 8.35072 24.9134 8.75924 22.9102H11.4844C12.9383 22.9102 14.1211 21.7274 14.1211 20.2734V6.21094C14.1211 4.75699 12.9383 3.57422 11.4844 3.57422H2.69531C1.24137 3.57422 0 4.75699 0 6.21094V20.2734C0 21.7274 1.24137 22.9102 2.69531 22.9102ZM7.08984 8.84766C9.51287 8.84766 11.4844 10.8192 11.4844 13.2422C11.4844 14.1363 11.2129 14.967 10.7522 15.6618L11.2269 16.1364C11.5702 16.4797 11.5702 17.036 11.2269 17.3793C10.8836 17.7226 10.3274 17.7226 9.98408 17.3793L9.50941 16.9046C8.81461 17.3652 7.98398 17.6367 7.08984 17.6367C4.66682 17.6367 2.69531 15.6652 2.69531 13.2422C2.69531 10.8192 4.66682 8.84766 7.08984 8.84766ZM22.1351 13.2422H23.6852L22.9102 11.6921L22.1351 13.2422Z"
      fill="#7A7A7A"
    />
    <path
      d="M27.3047 3.57422H18.5156C17.0617 3.57422 15.8789 4.75699 15.8789 6.21094V20.2734C15.8789 21.7274 17.0617 22.9102 18.5156 22.9102H21.2408C21.6493 24.9134 23.4243 26.4258 25.5469 26.4258H27.3047C27.7905 26.4258 28.1836 26.0327 28.1836 25.5469C28.1836 25.0611 27.7905 24.668 27.3047 24.668C26.8198 24.668 26.4258 24.274 26.4258 23.7891V22.9102H27.3047C28.7586 22.9102 30 21.7274 30 20.2734V6.21094C30 4.75699 28.7586 3.57422 27.3047 3.57422ZM26.8189 17.544C26.6103 17.6481 26.369 17.6652 26.1479 17.5915C25.9268 17.5178 25.7439 17.3593 25.6396 17.1509L24.5641 15H21.2562L20.1808 17.1509C19.9637 17.5843 19.4341 17.7612 19.0015 17.544C18.5672 17.3269 18.3912 16.799 18.6084 16.3647L22.124 9.33346C22.4227 8.73779 23.3977 8.73779 23.6964 9.33346L27.2121 16.3647C27.4291 16.799 27.2532 17.3269 26.8189 17.544Z"
      fill="#7A7A7A"
    />
  </svg>
);
